/**
 @typedef {Object} ScannedCode
 @property {string} prefix
 @property {string} barcode
 */
/**
 @typedef {Object.<any>} Property_Generic
 @property {string} value
 @property {string} error
 @property {string} type
 @property {bool} required
 @property {bool} update
 @property {string} label
 @property {string} helper
 @property {array} set
 @property {bool} searchable
 @property {bool} queryable
 @property {bool} visible
 @property {?string} override
 @property {?string} reference
 @property {Object} range
 @property {name} pkey
 */
/**
 @typedef {Object.<any>} Accounts
 @property {Accounts_Properties} properties
 @property {Accounts_Has} has
 @property {Accounts_Is} is
 @property {Accounts_Object} object
 */
/**
 @typedef {Object.<any>} Accounts_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {email} email
 @property {number|int} external_id
 @property {number|int} external_service
 @property {text|string} ffl_boss_email
 @property {boolean} fflboss_pos_combo
 @property {boolean} has_altrupay
 @property {boolean} has_trialed
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name_first
 @property {text|string} name_last
 @property {string} password
 @property {string} password_temp
 @property {number|int} pkey
 @property {string} password_new
 @property {string} password_re
 @property {text|string} reference_id
 */
/**
 @typedef {Object.<any>} Accounts_Has
 */
/**
 @typedef {Object.<any>} Accounts_Is
 @property {External_Services_Object} external_services
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Accounts_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?email} email
 @property {string} email_error
 @property {?number|int} external_id
 @property {string} external_id_error
 @property {?number|int} external_service
 @property {string} external_service_error
 @property {?text|string} ffl_boss_email
 @property {string} ffl_boss_email_error
 @property {?boolean} fflboss_pos_combo
 @property {string} fflboss_pos_combo_error
 @property {?boolean} has_altrupay
 @property {string} has_altrupay_error
 @property {?boolean} has_trialed
 @property {string} has_trialed_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name_first
 @property {string} name_first_error
 @property {?text|string} name_last
 @property {string} name_last_error
 @property {?string} password
 @property {string} password_error
 @property {?string} password_temp
 @property {string} password_temp_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?string} password_new
 @property {string} password_new_error
 @property {?string} password_re
 @property {string} password_re_error
 @property {?text|string} reference_id
 @property {string} reference_id_error
 @property {External_Services_Object} external_services
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Accounts_Billing
 @property {Accounts_Billing_Properties} properties
 @property {Accounts_Billing_Has} has
 @property {Accounts_Billing_Is} is
 @property {Accounts_Billing_Object} object
 */
/**
 @typedef {Object.<any>} Accounts_Billing_Properties
 @property {text|string} token
 */
/**
 @typedef {Object.<any>} Accounts_Billing_Has
 */
/**
 @typedef {Object.<any>} Accounts_Billing_Is
 */
/**
 @typedef {Object.<any>} Accounts_Billing_Object
 @property {?text|string} token
 @property {string} token_error
 */
/**
 @typedef {Object.<any>} Accounts_Create
 @property {Accounts_Create_Properties} properties
 @property {Accounts_Create_Has} has
 @property {Accounts_Create_Is} is
 @property {Accounts_Create_Object} object
 */
/**
 @typedef {Object.<any>} Accounts_Create_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int} pkey
 @property {text|string} city
 @property {text|string} description
 @property {email} email
 @property {text|string} ffl
 @property {text|string} ffl_boss_email
 @property {boolean} fflboss_addon
 @property {text|string} fflboss_plan
 @property {boolean} is_tactical
 @property {text|string} name
 @property {text|string} name_company
 @property {text|string} name_first
 @property {text|string} name_last
 @property {text|string} name_legal
 @property {string} password
 @property {string} password_re
 @property {text|string} phone
 @property {number|int} processor
 @property {number|int} quantity
 @property {text|string} reference_id
 @property {array} selectedAddOns
 @property {text|string} selectedPlan
 @property {text|string} signup_url
 @property {text|string} state
 @property {text|string} store_number
 @property {text|string} street_1
 @property {text|string} street_2
 @property {number|int|float} tax_rate_city
 @property {number|int|float} tax_rate_county
 @property {number|int|float} tax_rate_special
 @property {number|int|float} tax_rate_state
 @property {boolean} tos
 @property {text|string} zip
 */
/**
 @typedef {Object.<any>} Accounts_Create_Has
 */
/**
 @typedef {Object.<any>} Accounts_Create_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Accounts_Create_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} city
 @property {string} city_error
 @property {?text|string} description
 @property {string} description_error
 @property {?email} email
 @property {string} email_error
 @property {?text|string} ffl
 @property {string} ffl_error
 @property {?text|string} ffl_boss_email
 @property {string} ffl_boss_email_error
 @property {?boolean} fflboss_addon
 @property {string} fflboss_addon_error
 @property {?text|string} fflboss_plan
 @property {string} fflboss_plan_error
 @property {?boolean} is_tactical
 @property {string} is_tactical_error
 @property {?text|string} name
 @property {string} name_error
 @property {?text|string} name_company
 @property {string} name_company_error
 @property {?text|string} name_first
 @property {string} name_first_error
 @property {?text|string} name_last
 @property {string} name_last_error
 @property {?text|string} name_legal
 @property {string} name_legal_error
 @property {?string} password
 @property {string} password_error
 @property {?string} password_re
 @property {string} password_re_error
 @property {?text|string} phone
 @property {string} phone_error
 @property {?number|int} processor
 @property {string} processor_error
 @property {?number|int} quantity
 @property {string} quantity_error
 @property {?text|string} reference_id
 @property {string} reference_id_error
 @property {?array} selectedAddOns
 @property {string} selectedAddOns_error
 @property {?text|string} selectedPlan
 @property {string} selectedPlan_error
 @property {?text|string} signup_url
 @property {string} signup_url_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} store_number
 @property {string} store_number_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?text|string} street_2
 @property {string} street_2_error
 @property {?number|int|float} tax_rate_city
 @property {string} tax_rate_city_error
 @property {?number|int|float} tax_rate_county
 @property {string} tax_rate_county_error
 @property {?number|int|float} tax_rate_special
 @property {string} tax_rate_special_error
 @property {?number|int|float} tax_rate_state
 @property {string} tax_rate_state_error
 @property {?boolean} tos
 @property {string} tos_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Accounts_Customizations
 @property {Accounts_Customizations_Properties} properties
 @property {Accounts_Customizations_Has} has
 @property {Accounts_Customizations_Is} is
 @property {Accounts_Customizations_Object} object
 */
/**
 @typedef {Object.<any>} Accounts_Customizations_Properties
 @property {number|int} account
 @property {boolean} allow_debit
 @property {boolean} allow_zelle
 @property {text|string} ammoready_apikey
 @property {boolean} ammoready_enabled
 @property {text|string} ammoready_password
 @property {boolean} ammoready_synctype
 @property {text|string} ammoready_username
 @property {boolean} apply_cc_fee_to_debit
 @property {boolean} auto_cc_fee
 @property {boolean} auto_invoice
 @property {boolean} auto_send_invoice_email
 @property {text|string} cash_discount_payment_types
 @property {number|int|float} cash_discount_percentage
 @property {boolean} cash_discounting
 @property {date|string} created
 @property {number|int} creator
 @property {boolean} ffl_customer_copy
 @property {boolean} ffl_force_taxable
 @property {boolean} has_range_manager
 @property {boolean} invoicing_enabled
 @property {string} logo
 @property {text|string} max_quantity
 @property {text|string} membership_api_key
 @property {text|string} membership_secret_key
 @property {text|string} message
 @property {date|string} modified
 @property {number|int} modifier
 @property {boolean} new_checkout
 @property {boolean} pay_by_link_enabled
 @property {number|int} pkey
 @property {boolean} quick_checkout_enabled
 @property {boolean} register_audit_denominations
 @property {text|string} register_default_denominations
 @property {boolean} register_require_variance_note
 @property {number|int|float} retained_float
 @property {text|string} return_policy
 @property {boolean} show_consignments
 @property {boolean} show_customer_info
 @property {boolean} show_layaways
 @property {boolean} show_tax_breakdown
 @property {boolean} show_trade_ins
 @property {boolean} skip_print_preview
 @property {boolean} use_new_sidenav
 @property {text|string} warranty
 */
/**
 @typedef {Object.<any>} Accounts_Customizations_Has
 */
/**
 @typedef {Object.<any>} Accounts_Customizations_Is
 @property {Accounts_Object} accounts
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Accounts_Customizations_Object
 @property {?number|int} account
 @property {string} account_error
 @property {?boolean} allow_debit
 @property {string} allow_debit_error
 @property {?boolean} allow_zelle
 @property {string} allow_zelle_error
 @property {?text|string} ammoready_apikey
 @property {string} ammoready_apikey_error
 @property {?boolean} ammoready_enabled
 @property {string} ammoready_enabled_error
 @property {?text|string} ammoready_password
 @property {string} ammoready_password_error
 @property {?boolean} ammoready_synctype
 @property {string} ammoready_synctype_error
 @property {?text|string} ammoready_username
 @property {string} ammoready_username_error
 @property {?boolean} apply_cc_fee_to_debit
 @property {string} apply_cc_fee_to_debit_error
 @property {?boolean} auto_cc_fee
 @property {string} auto_cc_fee_error
 @property {?boolean} auto_invoice
 @property {string} auto_invoice_error
 @property {?boolean} auto_send_invoice_email
 @property {string} auto_send_invoice_email_error
 @property {?text|string} cash_discount_payment_types
 @property {string} cash_discount_payment_types_error
 @property {?number|int|float} cash_discount_percentage
 @property {string} cash_discount_percentage_error
 @property {?boolean} cash_discounting
 @property {string} cash_discounting_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?boolean} ffl_customer_copy
 @property {string} ffl_customer_copy_error
 @property {?boolean} ffl_force_taxable
 @property {string} ffl_force_taxable_error
 @property {?boolean} has_range_manager
 @property {string} has_range_manager_error
 @property {?boolean} invoicing_enabled
 @property {string} invoicing_enabled_error
 @property {?string} logo
 @property {string} logo_error
 @property {?text|string} max_quantity
 @property {string} max_quantity_error
 @property {?text|string} membership_api_key
 @property {string} membership_api_key_error
 @property {?text|string} membership_secret_key
 @property {string} membership_secret_key_error
 @property {?text|string} message
 @property {string} message_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?boolean} new_checkout
 @property {string} new_checkout_error
 @property {?boolean} pay_by_link_enabled
 @property {string} pay_by_link_enabled_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?boolean} quick_checkout_enabled
 @property {string} quick_checkout_enabled_error
 @property {?boolean} register_audit_denominations
 @property {string} register_audit_denominations_error
 @property {?text|string} register_default_denominations
 @property {string} register_default_denominations_error
 @property {?boolean} register_require_variance_note
 @property {string} register_require_variance_note_error
 @property {?number|int|float} retained_float
 @property {string} retained_float_error
 @property {?text|string} return_policy
 @property {string} return_policy_error
 @property {?boolean} show_consignments
 @property {string} show_consignments_error
 @property {?boolean} show_customer_info
 @property {string} show_customer_info_error
 @property {?boolean} show_layaways
 @property {string} show_layaways_error
 @property {?boolean} show_tax_breakdown
 @property {string} show_tax_breakdown_error
 @property {?boolean} show_trade_ins
 @property {string} show_trade_ins_error
 @property {?boolean} skip_print_preview
 @property {string} skip_print_preview_error
 @property {?boolean} use_new_sidenav
 @property {string} use_new_sidenav_error
 @property {?text|string} warranty
 @property {string} warranty_error
 @property {Accounts_Object} accounts
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Admins_Locations
 @property {Admins_Locations_Properties} properties
 @property {Admins_Locations_Has} has
 @property {Admins_Locations_Is} is
 @property {Admins_Locations_Object} object
 */
/**
 @typedef {Object.<any>} Admins_Locations_Properties
 @property {number|int} account
 @property {text|string} city
 @property {date|string} created
 @property {number|int} creator
 @property {number|int|float} credit_card_fee
 @property {text|string} description
 @property {email} email
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {text|string} phone
 @property {number|int} pkey
 @property {text|string} state
 @property {text|string} store_number
 @property {text|string} street_1
 @property {text|string} street_2
 @property {number|int|float} tax_rate_city
 @property {number|int|float} tax_rate_county
 @property {number|int|float} tax_rate_fflboss
 @property {number|int|float} tax_rate_special
 @property {number|int|float} tax_rate_state
 @property {text|string} zip
 */
/**
 @typedef {Object.<any>} Admins_Locations_Has
 */
/**
 @typedef {Object.<any>} Admins_Locations_Is
 @property {Accounts_Object} accounts
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Admins_Locations_Object
 @property {?number|int} account
 @property {string} account_error
 @property {?text|string} city
 @property {string} city_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int|float} credit_card_fee
 @property {string} credit_card_fee_error
 @property {?text|string} description
 @property {string} description_error
 @property {?email} email
 @property {string} email_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?text|string} phone
 @property {string} phone_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} store_number
 @property {string} store_number_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?text|string} street_2
 @property {string} street_2_error
 @property {?number|int|float} tax_rate_city
 @property {string} tax_rate_city_error
 @property {?number|int|float} tax_rate_county
 @property {string} tax_rate_county_error
 @property {?number|int|float} tax_rate_fflboss
 @property {string} tax_rate_fflboss_error
 @property {?number|int|float} tax_rate_special
 @property {string} tax_rate_special_error
 @property {?number|int|float} tax_rate_state
 @property {string} tax_rate_state_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {Accounts_Object} accounts
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Admins_Logins
 @property {Admins_Logins_Properties} properties
 @property {Admins_Logins_Has} has
 @property {Admins_Logins_Is} is
 @property {Admins_Logins_Object} object
 */
/**
 @typedef {Object.<any>} Admins_Logins_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {date|string} date
 @property {text|string} email
 @property {text|string} geo
 @property {text|string} ip
 @property {text|string} location
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int} pkey
 @property {boolean} successful
 */
/**
 @typedef {Object.<any>} Admins_Logins_Has
 */
/**
 @typedef {Object.<any>} Admins_Logins_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Admins_Logins_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?date|string} date
 @property {string} date_error
 @property {?text|string} email
 @property {string} email_error
 @property {?text|string} geo
 @property {string} geo_error
 @property {?text|string} ip
 @property {string} ip_error
 @property {?text|string} location
 @property {string} location_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?boolean} successful
 @property {string} successful_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Accounts_Processors
 @property {Accounts_Processors_Properties} properties
 @property {Accounts_Processors_Has} has
 @property {Accounts_Processors_Is} is
 @property {Accounts_Processors_Object} object
 */
/**
 @typedef {Object.<any>} Accounts_Processors_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int} pkey
 @property {text|string} reference_id
 */
/**
 @typedef {Object.<any>} Accounts_Processors_Has
 */
/**
 @typedef {Object.<any>} Accounts_Processors_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Accounts_Processors_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} reference_id
 @property {string} reference_id_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Admins_Securities
 @property {Admins_Securities_Properties} properties
 @property {Admins_Securities_Has} has
 @property {Admins_Securities_Is} is
 @property {Admins_Securities_Object} object
 */
/**
 @typedef {Object.<any>} Admins_Securities_Properties
 @property {number|int} account
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} email
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {number|int} pkey
 @property {text|string} token
 */
/**
 @typedef {Object.<any>} Admins_Securities_Has
 */
/**
 @typedef {Object.<any>} Admins_Securities_Is
 @property {Accounts_Object} accounts
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Admins_Securities_Object
 @property {?number|int} account
 @property {string} account_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} email
 @property {string} email_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} token
 @property {string} token_error
 @property {Accounts_Object} accounts
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Accounts_Subscriptions
 @property {Accounts_Subscriptions_Properties} properties
 @property {Accounts_Subscriptions_Has} has
 @property {Accounts_Subscriptions_Is} is
 @property {Accounts_Subscriptions_Object} object
 */
/**
 @typedef {Object.<any>} Accounts_Subscriptions_Properties
 @property {number|int} plan
 @property {number|int} quantity
 @property {number|int} current_period_end
 @property {text|string} monthly_amount
 @property {text|string} plan_name
 @property {number|int} trial_end
 */
/**
 @typedef {Object.<any>} Accounts_Subscriptions_Has
 */
/**
 @typedef {Object.<any>} Accounts_Subscriptions_Is
 @property {Stripe_Plans_Object} stripe_plans
 */
/**
 @typedef {Object.<any>} Accounts_Subscriptions_Object
 @property {?number|int} plan
 @property {string} plan_error
 @property {?number|int} quantity
 @property {string} quantity_error
 @property {?number|int} current_period_end
 @property {string} current_period_end_error
 @property {?text|string} monthly_amount
 @property {string} monthly_amount_error
 @property {?text|string} plan_name
 @property {string} plan_name_error
 @property {?number|int} trial_end
 @property {string} trial_end_error
 @property {Stripe_Plans_Object} stripe_plans
 */
/**
 @typedef {Object.<any>} Accounts_Tokens
 @property {Accounts_Tokens_Properties} properties
 @property {Accounts_Tokens_Has} has
 @property {Accounts_Tokens_Is} is
 @property {Accounts_Tokens_Object} object
 */
/**
 @typedef {Object.<any>} Accounts_Tokens_Properties
 @property {number|int} account
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} email
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {number|int} pkey
 @property {text|string} token
 */
/**
 @typedef {Object.<any>} Accounts_Tokens_Has
 */
/**
 @typedef {Object.<any>} Accounts_Tokens_Is
 @property {Accounts_Object} accounts
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Accounts_Tokens_Object
 @property {?number|int} account
 @property {string} account_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} email
 @property {string} email_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} token
 @property {string} token_error
 @property {Accounts_Object} accounts
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Admins
 @property {Admins_Properties} properties
 @property {Admins_Has} has
 @property {Admins_Is} is
 @property {Admins_Object} object
 */
/**
 @typedef {Object.<any>} Admins_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {email} email
 @property {text|string} last_ip
 @property {date|string} modified
 @property {number|int} modifier
 @property {string} password
 @property {number|int} pkey
 @property {text|string} g_recaptcha_response
 */
/**
 @typedef {Object.<any>} Admins_Has
 */
/**
 @typedef {Object.<any>} Admins_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Admins_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?email} email
 @property {string} email_error
 @property {?text|string} last_ip
 @property {string} last_ip_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?string} password
 @property {string} password_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} g_recaptcha_response
 @property {string} g_recaptcha_response_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Ammoready_Inventory
 @property {Ammoready_Inventory_Properties} properties
 @property {Ammoready_Inventory_Has} has
 @property {Ammoready_Inventory_Is} is
 @property {Ammoready_Inventory_Object} object
 */
/**
 @typedef {Object.<any>} Ammoready_Inventory_Properties
 @property {number|int} account
 @property {text|string} ammoready_id
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} description
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {number|int} pkey
 @property {number|int} pos_inventory
 @property {number|int} price
 @property {number|int} quantity
 @property {boolean} should_sync
 @property {text|string} sku
 */
/**
 @typedef {Object.<any>} Ammoready_Inventory_Has
 */
/**
 @typedef {Object.<any>} Ammoready_Inventory_Is
 @property {Accounts_Object} accounts
 @property {Skus_Object} skus
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Ammoready_Inventory_Object
 @property {?number|int} account
 @property {string} account_error
 @property {?text|string} ammoready_id
 @property {string} ammoready_id_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} description
 @property {string} description_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} pos_inventory
 @property {string} pos_inventory_error
 @property {?number|int} price
 @property {string} price_error
 @property {?number|int} quantity
 @property {string} quantity_error
 @property {?boolean} should_sync
 @property {string} should_sync_error
 @property {?text|string} sku
 @property {string} sku_error
 @property {Accounts_Object} accounts
 @property {Skus_Object} skus
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Certificates
 @property {Certificates_Properties} properties
 @property {Certificates_Has} has
 @property {Certificates_Is} is
 @property {Certificates_Object} object
 */
/**
 @typedef {Object.<any>} Certificates_Properties
 @property {text|string} code
 @property {date|string} created
 @property {number|int} creator
 @property {email} email
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {number|int|float} original_amount
 @property {text|string} phone
 @property {number|int} pkey
 @property {boolean} used
 @property {number|int|float} value
 */
/**
 @typedef {Object.<any>} Certificates_Has
 */
/**
 @typedef {Object.<any>} Certificates_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Certificates_Object
 @property {?text|string} code
 @property {string} code_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?email} email
 @property {string} email_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int|float} original_amount
 @property {string} original_amount_error
 @property {?text|string} phone
 @property {string} phone_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?boolean} used
 @property {string} used_error
 @property {?number|int|float} value
 @property {string} value_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Checkout_Quick_Picks
 @property {Checkout_Quick_Picks_Properties} properties
 @property {Checkout_Quick_Picks_Has} has
 @property {Checkout_Quick_Picks_Is} is
 @property {Checkout_Quick_Picks_Object} object
 */
/**
 @typedef {Object.<any>} Checkout_Quick_Picks_Properties
 @property {number|int} account
 @property {date|string} created
 @property {number|int} creator
 @property {number|int} entity_pkey
 @property {text|string} entity_type
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int} pkey
 @property {number|int} rank
 */
/**
 @typedef {Object.<any>} Checkout_Quick_Picks_Has
 */
/**
 @typedef {Object.<any>} Checkout_Quick_Picks_Is
 @property {Accounts_Object} accounts
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Checkout_Quick_Picks_Object
 @property {?number|int} account
 @property {string} account_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int} entity_pkey
 @property {string} entity_pkey_error
 @property {?text|string} entity_type
 @property {string} entity_type_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} rank
 @property {string} rank_error
 @property {Accounts_Object} accounts
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Checkouts
 @property {Checkouts_Properties} properties
 @property {Checkouts_Has} has
 @property {Checkouts_Is} is
 @property {Checkouts_Object} object
 */
/**
 @typedef {Object.<any>} Checkouts_Properties
 @property {number|int|float} amount
 @property {number|int|float} cash_amount
 @property {number|int|float} cash_discount_amount
 @property {number|int|float} cash_discount_percentage
 @property {number|int} certificate
 @property {number|int|float} check_amount
 @property {text|string} client
 @property {date|string} created
 @property {number|int} creator
 @property {number|int} customer
 @property {text|string} description
 @property {number|int|float} discount_amount
 @property {number|int|float} discount_percentage
 @property {number|int|float} invoice_amount
 @property {boolean} is_debit
 @property {number|int} location
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} notes
 @property {text|string} order_po_number
 @property {number|int|float} other_amount
 @property {number|int} pkey
 @property {number|int|float} processor_amount
 @property {text|string} receipt_email
 @property {number|int} register
 @property {text|string} salesman
 @property {text|string} uuid
 @property {number|int|float} zelle_amount
 @property {text|string} alignment
 @property {number|int|float} card_amount
 @property {number|int|float} cc_fee_amount
 @property {array} changing_items
 @property {text|string} credit_card_cvc
 @property {text|string} credit_card_expiry
 @property {text|string} credit_card_name
 @property {text|string} credit_card_number
 @property {array} customer_information
 @property {array} gift_certificates
 @property {boolean} layaway
 @property {number|int} layawayPkey
 @property {array} product_information
 @property {number|int|float} remaining
 @property {text|string} sudo_card
 @property {number|int|float} tax_amount
 @property {boolean} taxable
 @property {text|string} terminal
 @property {number|int} workOrderPkey
 @property {boolean} work_order
 */
/**
 @typedef {Object.<any>} Checkouts_Has
 @property {Checkouts_Items_Object[]} 0
 @property {Checkouts_Products_Object[]} 1
 @property {Checkouts_Consignments_Object[]} 2
 @property {Checkouts_Trades_Object[]} 3
 @property {Checkouts_Services_Object[]} 4
 @property {Checkouts_Layaways_Object[]} 5
 @property {Checkouts_Work_Orders_Object[]} 6
 @property {Transactions_Certificates_Object[]} 7
 */
/**
 @typedef {Object.<any>} Checkouts_Is
 @property {Certificates_Object} certificates
 @property {Customers_Object} customers
 @property {Locations_Object} locations
 @property {Registers_Object} registers
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Checkouts_Object
 @property {?number|int|float} amount
 @property {string} amount_error
 @property {?number|int|float} cash_amount
 @property {string} cash_amount_error
 @property {?number|int|float} cash_discount_amount
 @property {string} cash_discount_amount_error
 @property {?number|int|float} cash_discount_percentage
 @property {string} cash_discount_percentage_error
 @property {?number|int} certificate
 @property {string} certificate_error
 @property {?number|int|float} check_amount
 @property {string} check_amount_error
 @property {?text|string} client
 @property {string} client_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?text|string} description
 @property {string} description_error
 @property {?number|int|float} discount_amount
 @property {string} discount_amount_error
 @property {?number|int|float} discount_percentage
 @property {string} discount_percentage_error
 @property {?number|int|float} invoice_amount
 @property {string} invoice_amount_error
 @property {?boolean} is_debit
 @property {string} is_debit_error
 @property {?number|int} location
 @property {string} location_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?text|string} order_po_number
 @property {string} order_po_number_error
 @property {?number|int|float} other_amount
 @property {string} other_amount_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} processor_amount
 @property {string} processor_amount_error
 @property {?text|string} receipt_email
 @property {string} receipt_email_error
 @property {?number|int} register
 @property {string} register_error
 @property {?text|string} salesman
 @property {string} salesman_error
 @property {?text|string} uuid
 @property {string} uuid_error
 @property {?number|int|float} zelle_amount
 @property {string} zelle_amount_error
 @property {?text|string} alignment
 @property {string} alignment_error
 @property {?number|int|float} card_amount
 @property {string} card_amount_error
 @property {?number|int|float} cc_fee_amount
 @property {string} cc_fee_amount_error
 @property {?array} changing_items
 @property {string} changing_items_error
 @property {?text|string} credit_card_cvc
 @property {string} credit_card_cvc_error
 @property {?text|string} credit_card_expiry
 @property {string} credit_card_expiry_error
 @property {?text|string} credit_card_name
 @property {string} credit_card_name_error
 @property {?text|string} credit_card_number
 @property {string} credit_card_number_error
 @property {?array} customer_information
 @property {string} customer_information_error
 @property {?array} gift_certificates
 @property {string} gift_certificates_error
 @property {?boolean} layaway
 @property {string} layaway_error
 @property {?number|int} layawayPkey
 @property {string} layawayPkey_error
 @property {?array} product_information
 @property {string} product_information_error
 @property {?number|int|float} remaining
 @property {string} remaining_error
 @property {?text|string} sudo_card
 @property {string} sudo_card_error
 @property {?number|int|float} tax_amount
 @property {string} tax_amount_error
 @property {?boolean} taxable
 @property {string} taxable_error
 @property {?text|string} terminal
 @property {string} terminal_error
 @property {?number|int} workOrderPkey
 @property {string} workOrderPkey_error
 @property {?boolean} work_order
 @property {string} work_order_error
 @property {Checkouts_Items_Object[]} 0
 @property {Checkouts_Products_Object[]} 1
 @property {Checkouts_Consignments_Object[]} 2
 @property {Checkouts_Trades_Object[]} 3
 @property {Checkouts_Services_Object[]} 4
 @property {Checkouts_Layaways_Object[]} 5
 @property {Checkouts_Work_Orders_Object[]} 6
 @property {Transactions_Certificates_Object[]} 7
 @property {Certificates_Object} certificates
 @property {Customers_Object} customers
 @property {Locations_Object} locations
 @property {Registers_Object} registers
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Checkouts_Consignments
 @property {Checkouts_Consignments_Properties} properties
 @property {Checkouts_Consignments_Has} has
 @property {Checkouts_Consignments_Is} is
 @property {Checkouts_Consignments_Object} object
 */
/**
 @typedef {Object.<any>} Checkouts_Consignments_Properties
 @property {number|int} checkout
 @property {number|int} consignment
 @property {text|string} cost
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} discount_amount
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {number|int} pkey
 @property {number|int} quantity
 @property {text|string} serial
 @property {text|string} sku
 @property {boolean} taxable
 */
/**
 @typedef {Object.<any>} Checkouts_Consignments_Has
 */
/**
 @typedef {Object.<any>} Checkouts_Consignments_Is
 @property {Checkouts_Object} checkouts
 @property {Consignments_Object} consignments
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Checkouts_Consignments_Object
 @property {?number|int} checkout
 @property {string} checkout_error
 @property {?number|int} consignment
 @property {string} consignment_error
 @property {?text|string} cost
 @property {string} cost_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} discount_amount
 @property {string} discount_amount_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} quantity
 @property {string} quantity_error
 @property {?text|string} serial
 @property {string} serial_error
 @property {?text|string} sku
 @property {string} sku_error
 @property {?boolean} taxable
 @property {string} taxable_error
 @property {Checkouts_Object} checkouts
 @property {Consignments_Object} consignments
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Checkouts_Items
 @property {Checkouts_Items_Properties} properties
 @property {Checkouts_Items_Has} has
 @property {Checkouts_Items_Is} is
 @property {Checkouts_Items_Object} object
 */
/**
 @typedef {Object.<any>} Checkouts_Items_Properties
 @property {number|int} checkout
 @property {text|string} cost
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} discount_amount
 @property {number|int} inventory
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {number|int} pkey
 @property {number|int} quantity
 @property {text|string} serial
 @property {text|string} sku
 @property {boolean} taxable
 */
/**
 @typedef {Object.<any>} Checkouts_Items_Has
 */
/**
 @typedef {Object.<any>} Checkouts_Items_Is
 @property {Checkouts_Object} checkouts
 @property {Inventories_Object} inventories
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Checkouts_Items_Object
 @property {?number|int} checkout
 @property {string} checkout_error
 @property {?text|string} cost
 @property {string} cost_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} discount_amount
 @property {string} discount_amount_error
 @property {?number|int} inventory
 @property {string} inventory_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} quantity
 @property {string} quantity_error
 @property {?text|string} serial
 @property {string} serial_error
 @property {?text|string} sku
 @property {string} sku_error
 @property {?boolean} taxable
 @property {string} taxable_error
 @property {Checkouts_Object} checkouts
 @property {Inventories_Object} inventories
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Checkouts_Layaways
 @property {Checkouts_Layaways_Properties} properties
 @property {Checkouts_Layaways_Has} has
 @property {Checkouts_Layaways_Is} is
 @property {Checkouts_Layaways_Object} object
 */
/**
 @typedef {Object.<any>} Checkouts_Layaways_Properties
 @property {number|int} checkout
 @property {text|string} cost
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} discount_amount
 @property {number|int} layaway
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {number|int} pkey
 @property {number|int} quantity
 @property {text|string} serial
 @property {text|string} sku
 @property {boolean} taxable
 */
/**
 @typedef {Object.<any>} Checkouts_Layaways_Has
 */
/**
 @typedef {Object.<any>} Checkouts_Layaways_Is
 @property {Checkouts_Object} checkouts
 @property {Layaways_Object} layaways
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Checkouts_Layaways_Object
 @property {?number|int} checkout
 @property {string} checkout_error
 @property {?text|string} cost
 @property {string} cost_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} discount_amount
 @property {string} discount_amount_error
 @property {?number|int} layaway
 @property {string} layaway_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} quantity
 @property {string} quantity_error
 @property {?text|string} serial
 @property {string} serial_error
 @property {?text|string} sku
 @property {string} sku_error
 @property {?boolean} taxable
 @property {string} taxable_error
 @property {Checkouts_Object} checkouts
 @property {Layaways_Object} layaways
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Checkouts_Products
 @property {Checkouts_Products_Properties} properties
 @property {Checkouts_Products_Has} has
 @property {Checkouts_Products_Is} is
 @property {Checkouts_Products_Object} object
 */
/**
 @typedef {Object.<any>} Checkouts_Products_Properties
 @property {number|int} checkout
 @property {text|string} cost
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} discount_amount
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {number|int} pkey
 @property {number|int} product
 @property {text|string} serial
 @property {text|string} sku
 @property {boolean} taxable
 */
/**
 @typedef {Object.<any>} Checkouts_Products_Has
 */
/**
 @typedef {Object.<any>} Checkouts_Products_Is
 @property {Checkouts_Object} checkouts
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Checkouts_Products_Object
 @property {?number|int} checkout
 @property {string} checkout_error
 @property {?text|string} cost
 @property {string} cost_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} discount_amount
 @property {string} discount_amount_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} product
 @property {string} product_error
 @property {?text|string} serial
 @property {string} serial_error
 @property {?text|string} sku
 @property {string} sku_error
 @property {?boolean} taxable
 @property {string} taxable_error
 @property {Checkouts_Object} checkouts
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Checkouts_Services
 @property {Checkouts_Services_Properties} properties
 @property {Checkouts_Services_Has} has
 @property {Checkouts_Services_Is} is
 @property {Checkouts_Services_Object} object
 */
/**
 @typedef {Object.<any>} Checkouts_Services_Properties
 @property {number|int} checkout
 @property {text|string} cost
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} discount_amount
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {number|int} pkey
 @property {number|int} quantity
 @property {number|int} service
 @property {boolean} taxable
 */
/**
 @typedef {Object.<any>} Checkouts_Services_Has
 */
/**
 @typedef {Object.<any>} Checkouts_Services_Is
 @property {Checkouts_Object} checkouts
 @property {Services_Object} services
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Checkouts_Services_Object
 @property {?number|int} checkout
 @property {string} checkout_error
 @property {?text|string} cost
 @property {string} cost_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} discount_amount
 @property {string} discount_amount_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} quantity
 @property {string} quantity_error
 @property {?number|int} service
 @property {string} service_error
 @property {?boolean} taxable
 @property {string} taxable_error
 @property {Checkouts_Object} checkouts
 @property {Services_Object} services
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Checkouts_Trades
 @property {Checkouts_Trades_Properties} properties
 @property {Checkouts_Trades_Has} has
 @property {Checkouts_Trades_Is} is
 @property {Checkouts_Trades_Object} object
 */
/**
 @typedef {Object.<any>} Checkouts_Trades_Properties
 @property {number|int} checkout
 @property {date|string} created
 @property {number|int} creator
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int} pkey
 @property {number|int} quantity
 @property {number|int} trade
 */
/**
 @typedef {Object.<any>} Checkouts_Trades_Has
 */
/**
 @typedef {Object.<any>} Checkouts_Trades_Is
 @property {Checkouts_Object} checkouts
 @property {Trades_Object} trades
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Checkouts_Trades_Object
 @property {?number|int} checkout
 @property {string} checkout_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} quantity
 @property {string} quantity_error
 @property {?number|int} trade
 @property {string} trade_error
 @property {Checkouts_Object} checkouts
 @property {Trades_Object} trades
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Checkouts_Work_Orders
 @property {Checkouts_Work_Orders_Properties} properties
 @property {Checkouts_Work_Orders_Has} has
 @property {Checkouts_Work_Orders_Is} is
 @property {Checkouts_Work_Orders_Object} object
 */
/**
 @typedef {Object.<any>} Checkouts_Work_Orders_Properties
 @property {number|int} checkout
 @property {text|string} cost
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} discount_amount
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {number|int} pkey
 @property {number|int} quantity
 @property {text|string} serial
 @property {text|string} sku
 @property {boolean} taxable
 @property {number|int} work_order
 */
/**
 @typedef {Object.<any>} Checkouts_Work_Orders_Has
 */
/**
 @typedef {Object.<any>} Checkouts_Work_Orders_Is
 @property {Checkouts_Object} checkouts
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 @property {Work_Orders_Object} work_orders
 */
/**
 @typedef {Object.<any>} Checkouts_Work_Orders_Object
 @property {?number|int} checkout
 @property {string} checkout_error
 @property {?text|string} cost
 @property {string} cost_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} discount_amount
 @property {string} discount_amount_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} quantity
 @property {string} quantity_error
 @property {?text|string} serial
 @property {string} serial_error
 @property {?text|string} sku
 @property {string} sku_error
 @property {?boolean} taxable
 @property {string} taxable_error
 @property {?number|int} work_order
 @property {string} work_order_error
 @property {Checkouts_Object} checkouts
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 @property {Work_Orders_Object} work_orders
 */
/**
 @typedef {Object.<any>} Consignments
 @property {Consignments_Properties} properties
 @property {Consignments_Has} has
 @property {Consignments_Is} is
 @property {Consignments_Object} object
 */
/**
 @typedef {Object.<any>} Consignments_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {text|string} notes
 @property {number|int} pkey
 @property {text|string} poc
 @property {number|int|float} price
 @property {number|int|float} quantity
 @property {boolean} taxable
 @property {text|string} terms
 */
/**
 @typedef {Object.<any>} Consignments_Has
 */
/**
 @typedef {Object.<any>} Consignments_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Consignments_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} poc
 @property {string} poc_error
 @property {?number|int|float} price
 @property {string} price_error
 @property {?number|int|float} quantity
 @property {string} quantity_error
 @property {?boolean} taxable
 @property {string} taxable_error
 @property {?text|string} terms
 @property {string} terms_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Customers
 @property {Customers_Properties} properties
 @property {Customers_Has} has
 @property {Customers_Is} is
 @property {Customers_Object} object
 */
/**
 @typedef {Object.<any>} Customers_Properties
 @property {date|string} birth_date
 @property {text|string} city
 @property {date|string} created
 @property {number|int} creator
 @property {boolean} cron_migrated_ffl
 @property {boolean} dl_scan_toggle
 @property {text|string} email
 @property {number|int} fflboss_pkey
 @property {date|string} identification_expiration
 @property {date|string} identification_issue
 @property {text|string} identification_number
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {text|string} phone
 @property {number|int} pkey
 @property {text|string} state
 @property {text|string} street_1
 @property {text|string} street_2
 @property {text|string} zip
 */
/**
 @typedef {Object.<any>} Customers_Has
 */
/**
 @typedef {Object.<any>} Customers_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Customers_Object
 @property {?date|string} birth_date
 @property {string} birth_date_error
 @property {?text|string} city
 @property {string} city_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?boolean} cron_migrated_ffl
 @property {string} cron_migrated_ffl_error
 @property {?boolean} dl_scan_toggle
 @property {string} dl_scan_toggle_error
 @property {?text|string} email
 @property {string} email_error
 @property {?number|int} fflboss_pkey
 @property {string} fflboss_pkey_error
 @property {?date|string} identification_expiration
 @property {string} identification_expiration_error
 @property {?date|string} identification_issue
 @property {string} identification_issue_error
 @property {?text|string} identification_number
 @property {string} identification_number_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?text|string} phone
 @property {string} phone_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?text|string} street_2
 @property {string} street_2_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Customers_Logs
 @property {Customers_Logs_Properties} properties
 @property {Customers_Logs_Has} has
 @property {Customers_Logs_Is} is
 @property {Customers_Logs_Object} object
 */
/**
 @typedef {Object.<any>} Customers_Logs_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {number|int} customer
 @property {text|string} field_changed
 @property {date|string} modified
 @property {text|string} modifier
 @property {number|int} pkey
 @property {text|string} value_new
 @property {text|string} value_original
 */
/**
 @typedef {Object.<any>} Customers_Logs_Has
 */
/**
 @typedef {Object.<any>} Customers_Logs_Is
 @property {Customers_Object} customers
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Customers_Logs_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?text|string} field_changed
 @property {string} field_changed_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?text|string} modifier
 @property {string} modifier_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} value_new
 @property {string} value_new_error
 @property {?text|string} value_original
 @property {string} value_original_error
 @property {Customers_Object} customers
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Dashboard
 @property {Dashboard_Properties} properties
 @property {Dashboard_Has} has
 @property {Dashboard_Is} is
 @property {Dashboard_Object} object
 */
/**
 @typedef {Object.<any>} Dashboard_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int} pkey
 @property {array} totals
 */
/**
 @typedef {Object.<any>} Dashboard_Has
 */
/**
 @typedef {Object.<any>} Dashboard_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Dashboard_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?array} totals
 @property {string} totals_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Inventories
 @property {Inventories_Properties} properties
 @property {Inventories_Has} has
 @property {Inventories_Is} is
 @property {Inventories_Object} object
 */
/**
 @typedef {Object.<any>} Inventories_Properties
 @property {number|int} account
 @property {date|string} created
 @property {number|int} creator
 @property {number|int} location
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int} pkey
 @property {number|int|float} quantity
 @property {number|int} sku
 @property {boolean} taxable
 @property {boolean} used
 @property {text|string} event_description
 */
/**
 @typedef {Object.<any>} Inventories_Has
 */
/**
 @typedef {Object.<any>} Inventories_Is
 @property {Accounts_Object} accounts
 @property {Locations_Object} locations
 @property {Skus_Object} skus
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Inventories_Object
 @property {?number|int} account
 @property {string} account_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int} location
 @property {string} location_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} quantity
 @property {string} quantity_error
 @property {?number|int} sku
 @property {string} sku_error
 @property {?boolean} taxable
 @property {string} taxable_error
 @property {?boolean} used
 @property {string} used_error
 @property {?text|string} event_description
 @property {string} event_description_error
 @property {Accounts_Object} accounts
 @property {Locations_Object} locations
 @property {Skus_Object} skus
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Inventories_Connected
 @property {Inventories_Connected_Properties} properties
 @property {Inventories_Connected_Has} has
 @property {Inventories_Connected_Is} is
 @property {Inventories_Connected_Object} object
 */
/**
 @typedef {Object.<any>} Inventories_Connected_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int} pkey
 @property {number|int|float} ffl_cost
 @property {number|int|float} ffl_price
 @property {text|string} sku
 */
/**
 @typedef {Object.<any>} Inventories_Connected_Has
 */
/**
 @typedef {Object.<any>} Inventories_Connected_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Inventories_Connected_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} ffl_cost
 @property {string} ffl_cost_error
 @property {?number|int|float} ffl_price
 @property {string} ffl_price_error
 @property {?text|string} sku
 @property {string} sku_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Inventories_Ledgers
 @property {Inventories_Ledgers_Properties} properties
 @property {Inventories_Ledgers_Has} has
 @property {Inventories_Ledgers_Is} is
 @property {Inventories_Ledgers_Object} object
 */
/**
 @typedef {Object.<any>} Inventories_Ledgers_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} event_description
 @property {number|int} inventory
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int} pkey
 @property {number|int|float} quantity
 @property {number|int} transaction
 @property {text|string} user_name
 */
/**
 @typedef {Object.<any>} Inventories_Ledgers_Has
 */
/**
 @typedef {Object.<any>} Inventories_Ledgers_Is
 @property {Inventories_Object} inventories
 @property {Transactions_Object} transactions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Inventories_Ledgers_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} event_description
 @property {string} event_description_error
 @property {?number|int} inventory
 @property {string} inventory_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} quantity
 @property {string} quantity_error
 @property {?number|int} transaction
 @property {string} transaction_error
 @property {?text|string} user_name
 @property {string} user_name_error
 @property {Inventories_Object} inventories
 @property {Transactions_Object} transactions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Inventories_Serialized
 @property {Inventories_Serialized_Properties} properties
 @property {Inventories_Serialized_Has} has
 @property {Inventories_Serialized_Is} is
 @property {Inventories_Serialized_Object} object
 */
/**
 @typedef {Object.<any>} Inventories_Serialized_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {number|int} inventory
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} notes
 @property {number|int} pkey
 @property {text|string} serial
 @property {boolean} sold
 */
/**
 @typedef {Object.<any>} Inventories_Serialized_Has
 */
/**
 @typedef {Object.<any>} Inventories_Serialized_Is
 @property {Inventories_Object} inventories
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Inventories_Serialized_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int} inventory
 @property {string} inventory_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} serial
 @property {string} serial_error
 @property {?boolean} sold
 @property {string} sold_error
 @property {Inventories_Object} inventories
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Invoice_Pay_By_Link
 @property {Invoice_Pay_By_Link_Properties} properties
 @property {Invoice_Pay_By_Link_Has} has
 @property {Invoice_Pay_By_Link_Is} is
 @property {Invoice_Pay_By_Link_Object} object
 */
/**
 @typedef {Object.<any>} Invoice_Pay_By_Link_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Invoice_Pay_By_Link_Has
 */
/**
 @typedef {Object.<any>} Invoice_Pay_By_Link_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Invoice_Pay_By_Link_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Invoices
 @property {Invoices_Properties} properties
 @property {Invoices_Has} has
 @property {Invoices_Is} is
 @property {Invoices_Object} object
 */
/**
 @typedef {Object.<any>} Invoices_Properties
 @property {number|int|float} amount
 @property {number|int|float} cash_amount
 @property {number|int|float} cash_discount_amount
 @property {number|int|float} cash_discount_percentage
 @property {number|int|float} cc_fee_amount
 @property {number|int} certificate
 @property {number|int|float} check_amount
 @property {text|string} client
 @property {date|string} created
 @property {number|int} creator
 @property {number|int} customer
 @property {date|string} date
 @property {text|string} description
 @property {number|int|float} discount_amount
 @property {number|int} discount_percentage
 @property {number|int|float} invoice_amount
 @property {text|string} invoice_notes
 @property {number|int|float} invoice_remaining
 @property {number|int} invoice_status
 @property {boolean} is_debit
 @property {number|int} location
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} notes
 @property {text|string} order_id
 @property {text|string} order_ip_address
 @property {text|string} order_po_number
 @property {number|int|float} other_amount
 @property {text|string} payment_method
 @property {number|int} pkey
 @property {number|int|float} processor_amount
 @property {text|string} processor_user_id
 @property {text|string} receipt_email
 @property {boolean} refunded
 @property {text|string} salesman
 @property {text|string} signature_data
 @property {number|int|float} tax_amount
 @property {text|string} tax_json
 @property {text|string} terminal_card_type
 @property {text|string} terminal_cardholder_name
 @property {text|string} terminal_entry_type
 @property {text|string} terminal_id
 @property {number|int} terminal_last_four
 @property {text|string} terminal_payment_type
 @property {text|string} transaction_id
 @property {number|int} user
 @property {number|int|float} zelle_amount
 @property {text|string} note
 */
/**
 @typedef {Object.<any>} Invoices_Has
 @property {Transactions_Refunds_Object[]} 0
 @property {Transactions_Items_Object[]} 1
 @property {Transactions_Products_Object[]} 2
 @property {Transactions_Consignments_Object[]} 3
 @property {Transactions_Services_Object[]} 4
 @property {Transactions_Trades_Object[]} 5
 @property {Invoice_Payments_Object[]} 6
 */
/**
 @typedef {Object.<any>} Invoices_Is
 @property {Certificates_Object} certificates
 @property {Customers_Object} customers
 @property {Locations_Object} locations
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Invoices_Object
 @property {?number|int|float} amount
 @property {string} amount_error
 @property {?number|int|float} cash_amount
 @property {string} cash_amount_error
 @property {?number|int|float} cash_discount_amount
 @property {string} cash_discount_amount_error
 @property {?number|int|float} cash_discount_percentage
 @property {string} cash_discount_percentage_error
 @property {?number|int|float} cc_fee_amount
 @property {string} cc_fee_amount_error
 @property {?number|int} certificate
 @property {string} certificate_error
 @property {?number|int|float} check_amount
 @property {string} check_amount_error
 @property {?text|string} client
 @property {string} client_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?date|string} date
 @property {string} date_error
 @property {?text|string} description
 @property {string} description_error
 @property {?number|int|float} discount_amount
 @property {string} discount_amount_error
 @property {?number|int} discount_percentage
 @property {string} discount_percentage_error
 @property {?number|int|float} invoice_amount
 @property {string} invoice_amount_error
 @property {?text|string} invoice_notes
 @property {string} invoice_notes_error
 @property {?number|int|float} invoice_remaining
 @property {string} invoice_remaining_error
 @property {?number|int} invoice_status
 @property {string} invoice_status_error
 @property {?boolean} is_debit
 @property {string} is_debit_error
 @property {?number|int} location
 @property {string} location_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?text|string} order_id
 @property {string} order_id_error
 @property {?text|string} order_ip_address
 @property {string} order_ip_address_error
 @property {?text|string} order_po_number
 @property {string} order_po_number_error
 @property {?number|int|float} other_amount
 @property {string} other_amount_error
 @property {?text|string} payment_method
 @property {string} payment_method_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} processor_amount
 @property {string} processor_amount_error
 @property {?text|string} processor_user_id
 @property {string} processor_user_id_error
 @property {?text|string} receipt_email
 @property {string} receipt_email_error
 @property {?boolean} refunded
 @property {string} refunded_error
 @property {?text|string} salesman
 @property {string} salesman_error
 @property {?text|string} signature_data
 @property {string} signature_data_error
 @property {?number|int|float} tax_amount
 @property {string} tax_amount_error
 @property {?text|string} tax_json
 @property {string} tax_json_error
 @property {?text|string} terminal_card_type
 @property {string} terminal_card_type_error
 @property {?text|string} terminal_cardholder_name
 @property {string} terminal_cardholder_name_error
 @property {?text|string} terminal_entry_type
 @property {string} terminal_entry_type_error
 @property {?text|string} terminal_id
 @property {string} terminal_id_error
 @property {?number|int} terminal_last_four
 @property {string} terminal_last_four_error
 @property {?text|string} terminal_payment_type
 @property {string} terminal_payment_type_error
 @property {?text|string} transaction_id
 @property {string} transaction_id_error
 @property {?number|int} user
 @property {string} user_error
 @property {?number|int|float} zelle_amount
 @property {string} zelle_amount_error
 @property {?text|string} note
 @property {string} note_error
 @property {Transactions_Refunds_Object[]} 0
 @property {Transactions_Items_Object[]} 1
 @property {Transactions_Products_Object[]} 2
 @property {Transactions_Consignments_Object[]} 3
 @property {Transactions_Services_Object[]} 4
 @property {Transactions_Trades_Object[]} 5
 @property {Invoice_Payments_Object[]} 6
 @property {Certificates_Object} certificates
 @property {Customers_Object} customers
 @property {Locations_Object} locations
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Invoices_Payments
 @property {Invoices_Payments_Properties} properties
 @property {Invoices_Payments_Has} has
 @property {Invoices_Payments_Is} is
 @property {Invoices_Payments_Object} object
 */
/**
 @typedef {Object.<any>} Invoices_Payments_Properties
 @property {number|int|float} amount
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} event
 @property {text|string} method
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} notes
 @property {number|int} pkey
 @property {number|int} register
 @property {number|int|float} remaining_after
 @property {number|int} transaction
 */
/**
 @typedef {Object.<any>} Invoices_Payments_Has
 */
/**
 @typedef {Object.<any>} Invoices_Payments_Is
 @property {Registers_Object} registers
 @property {Transactions_Object} transactions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Invoices_Payments_Object
 @property {?number|int|float} amount
 @property {string} amount_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} event
 @property {string} event_error
 @property {?text|string} method
 @property {string} method_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} register
 @property {string} register_error
 @property {?number|int|float} remaining_after
 @property {string} remaining_after_error
 @property {?number|int} transaction
 @property {string} transaction_error
 @property {Registers_Object} registers
 @property {Transactions_Object} transactions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Kiosk_States
 @property {Kiosk_States_Properties} properties
 @property {Kiosk_States_Has} has
 @property {Kiosk_States_Is} is
 @property {Kiosk_States_Object} object
 */
/**
 @typedef {Object.<any>} Kiosk_States_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {number|int} kiosk_id
 @property {date|string} last_request_time
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int} pkey
 @property {date|string} updated_at
 @property {text|string} version
 */
/**
 @typedef {Object.<any>} Kiosk_States_Has
 */
/**
 @typedef {Object.<any>} Kiosk_States_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Kiosk_States_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int} kiosk_id
 @property {string} kiosk_id_error
 @property {?date|string} last_request_time
 @property {string} last_request_time_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?date|string} updated_at
 @property {string} updated_at_error
 @property {?text|string} version
 @property {string} version_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Kiosks
 @property {Kiosks_Properties} properties
 @property {Kiosks_Has} has
 @property {Kiosks_Is} is
 @property {Kiosks_Object} object
 */
/**
 @typedef {Object.<any>} Kiosks_Properties
 @property {number|int} account
 @property {text|string} actual_ip
 @property {string} ad_image_1
 @property {string} ad_image_2
 @property {string} ad_image_3
 @property {text|string} api_key
 @property {number|int} checkout
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_name
 @property {text|string} device
 @property {text|string} display_text
 @property {text|string} expected_ip
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_name
 @property {text|string} name
 @property {text|string} pair_code
 @property {number|int} pair_code_end_time
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Kiosks_Has
 */
/**
 @typedef {Object.<any>} Kiosks_Is
 @property {Checkouts_Object} checkouts
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Kiosks_Object
 @property {?number|int} account
 @property {string} account_error
 @property {?text|string} actual_ip
 @property {string} actual_ip_error
 @property {?string} ad_image_1
 @property {string} ad_image_1_error
 @property {?string} ad_image_2
 @property {string} ad_image_2_error
 @property {?string} ad_image_3
 @property {string} ad_image_3_error
 @property {?text|string} api_key
 @property {string} api_key_error
 @property {?number|int} checkout
 @property {string} checkout_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_name
 @property {string} creator_name_error
 @property {?text|string} device
 @property {string} device_error
 @property {?text|string} display_text
 @property {string} display_text_error
 @property {?text|string} expected_ip
 @property {string} expected_ip_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_name
 @property {string} modifier_name_error
 @property {?text|string} name
 @property {string} name_error
 @property {?text|string} pair_code
 @property {string} pair_code_error
 @property {?number|int} pair_code_end_time
 @property {string} pair_code_end_time_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {Checkouts_Object} checkouts
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Layaways
 @property {Layaways_Properties} properties
 @property {Layaways_Has} has
 @property {Layaways_Is} is
 @property {Layaways_Object} object
 */
/**
 @typedef {Object.<any>} Layaways_Properties
 @property {number|int} account
 @property {number|int|float} amount
 @property {number|int|float} cc_fees
 @property {date|string} completed_date
 @property {date|string} created
 @property {number|int} creator
 @property {number|int} customer
 @property {text|string} customer_notes
 @property {text|string} description
 @property {date|string} estimated_date
 @property {text|string} layaway_notes
 @property {number|int} location
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int|float} non_taxable_subtotal
 @property {number|int} pkey
 @property {text|string} po_number
 @property {text|string} receipt_email
 @property {number|int|float} remaining
 @property {text|string} salesman
 @property {number|int|float} tax_amount
 @property {text|string} tax_json
 @property {number|int|float} tax_rate
 @property {number|int|float} taxable_subtotal
 @property {number|int|float} amount_refunded
 @property {number|int|float} cash_amount
 @property {number|int|float} check_amount
 @property {text|string} credit_card_cvc
 @property {text|string} credit_card_expiry
 @property {text|string} credit_card_name
 @property {text|string} credit_card_number
 @property {text|string} description
 @property {array} entries
 @property {number|int|float} invoice_amount
 @property {boolean} is_debit
 @property {number|int|float} other_amount
 @property {number|int|float} processor_amount
 @property {number|int} register
 @property {number|int|float} remaining
 @property {number|int|float} sub_total_amount
 @property {number|int|float} tax_amount
 @property {text|string} tax_overpayment_action
 @property {number|int|float} tax_overpayment_amount
 @property {text|string} tax_overpayment_note
 @property {text|string} terminal
 @property {number|int|float} zelle_amount
 */
/**
 @typedef {Object.<any>} Layaways_Has
 @property {Layaways_Services_Object[]} 0
 */
/**
 @typedef {Object.<any>} Layaways_Is
 @property {Accounts_Object} accounts
 @property {Customers_Object} customers
 @property {Locations_Object} locations
 @property {Registers_Object} registers
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Layaways_Object
 @property {?number|int} account
 @property {string} account_error
 @property {?number|int|float} amount
 @property {string} amount_error
 @property {?number|int|float} cc_fees
 @property {string} cc_fees_error
 @property {?date|string} completed_date
 @property {string} completed_date_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?text|string} customer_notes
 @property {string} customer_notes_error
 @property {?text|string} description
 @property {string} description_error
 @property {?date|string} estimated_date
 @property {string} estimated_date_error
 @property {?text|string} layaway_notes
 @property {string} layaway_notes_error
 @property {?number|int} location
 @property {string} location_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int|float} non_taxable_subtotal
 @property {string} non_taxable_subtotal_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} po_number
 @property {string} po_number_error
 @property {?text|string} receipt_email
 @property {string} receipt_email_error
 @property {?number|int|float} remaining
 @property {string} remaining_error
 @property {?text|string} salesman
 @property {string} salesman_error
 @property {?number|int|float} tax_amount
 @property {string} tax_amount_error
 @property {?text|string} tax_json
 @property {string} tax_json_error
 @property {?number|int|float} tax_rate
 @property {string} tax_rate_error
 @property {?number|int|float} taxable_subtotal
 @property {string} taxable_subtotal_error
 @property {?number|int|float} amount_refunded
 @property {string} amount_refunded_error
 @property {?number|int|float} cash_amount
 @property {string} cash_amount_error
 @property {?number|int|float} check_amount
 @property {string} check_amount_error
 @property {?text|string} credit_card_cvc
 @property {string} credit_card_cvc_error
 @property {?text|string} credit_card_expiry
 @property {string} credit_card_expiry_error
 @property {?text|string} credit_card_name
 @property {string} credit_card_name_error
 @property {?text|string} credit_card_number
 @property {string} credit_card_number_error
 @property {?text|string} description
 @property {string} description_error
 @property {?array} entries
 @property {string} entries_error
 @property {?number|int|float} invoice_amount
 @property {string} invoice_amount_error
 @property {?boolean} is_debit
 @property {string} is_debit_error
 @property {?number|int|float} other_amount
 @property {string} other_amount_error
 @property {?number|int|float} processor_amount
 @property {string} processor_amount_error
 @property {?number|int} register
 @property {string} register_error
 @property {?number|int|float} remaining
 @property {string} remaining_error
 @property {?number|int|float} sub_total_amount
 @property {string} sub_total_amount_error
 @property {?number|int|float} tax_amount
 @property {string} tax_amount_error
 @property {?text|string} tax_overpayment_action
 @property {string} tax_overpayment_action_error
 @property {?number|int|float} tax_overpayment_amount
 @property {string} tax_overpayment_amount_error
 @property {?text|string} tax_overpayment_note
 @property {string} tax_overpayment_note_error
 @property {?text|string} terminal
 @property {string} terminal_error
 @property {?number|int|float} zelle_amount
 @property {string} zelle_amount_error
 @property {Layaways_Services_Object[]} 0
 @property {Accounts_Object} accounts
 @property {Customers_Object} customers
 @property {Locations_Object} locations
 @property {Registers_Object} registers
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Layaways_Entries
 @property {Layaways_Entries_Properties} properties
 @property {Layaways_Entries_Has} has
 @property {Layaways_Entries_Is} is
 @property {Layaways_Entries_Object} object
 */
/**
 @typedef {Object.<any>} Layaways_Entries_Properties
 @property {number|int|float} cost
 @property {date|string} created
 @property {number|int} creator
 @property {number|int|float} discount_amount
 @property {number|int} inventory
 @property {number|int} layaway
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {number|int} pkey
 @property {number|int|float} price
 @property {number|int} product
 @property {number|int} quantity
 @property {text|string} serial_number
 @property {text|string} sku
 @property {number|int|float} tax_rate
 @property {boolean} taxable
 @property {text|string} type
 */
/**
 @typedef {Object.<any>} Layaways_Entries_Has
 */
/**
 @typedef {Object.<any>} Layaways_Entries_Is
 @property {Inventories_Object} inventories
 @property {Layaways_Object} layaways
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Layaways_Entries_Object
 @property {?number|int|float} cost
 @property {string} cost_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int|float} discount_amount
 @property {string} discount_amount_error
 @property {?number|int} inventory
 @property {string} inventory_error
 @property {?number|int} layaway
 @property {string} layaway_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} price
 @property {string} price_error
 @property {?number|int} product
 @property {string} product_error
 @property {?number|int} quantity
 @property {string} quantity_error
 @property {?text|string} serial_number
 @property {string} serial_number_error
 @property {?text|string} sku
 @property {string} sku_error
 @property {?number|int|float} tax_rate
 @property {string} tax_rate_error
 @property {?boolean} taxable
 @property {string} taxable_error
 @property {?text|string} type
 @property {string} type_error
 @property {Inventories_Object} inventories
 @property {Layaways_Object} layaways
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Layaways_Items
 @property {Layaways_Items_Properties} properties
 @property {Layaways_Items_Has} has
 @property {Layaways_Items_Is} is
 @property {Layaways_Items_Object} object
 */
/**
 @typedef {Object.<any>} Layaways_Items_Properties
 @property {number|int|float} cost
 @property {date|string} created
 @property {number|int} creator
 @property {number|int|float} discount_amount
 @property {number|int} item_fkey
 @property {text|string} item_type
 @property {number|int} layaway
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {number|int} pkey
 @property {number|int|float} price
 @property {number|int} quantity
 @property {text|string} serial_number
 @property {text|string} sku
 @property {number|int|float} tax_rate
 @property {boolean} taxable
 @property {array} entries
 */
/**
 @typedef {Object.<any>} Layaways_Items_Has
 */
/**
 @typedef {Object.<any>} Layaways_Items_Is
 @property {Layaways_Object} layaways
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Layaways_Items_Object
 @property {?number|int|float} cost
 @property {string} cost_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int|float} discount_amount
 @property {string} discount_amount_error
 @property {?number|int} item_fkey
 @property {string} item_fkey_error
 @property {?text|string} item_type
 @property {string} item_type_error
 @property {?number|int} layaway
 @property {string} layaway_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} price
 @property {string} price_error
 @property {?number|int} quantity
 @property {string} quantity_error
 @property {?text|string} serial_number
 @property {string} serial_number_error
 @property {?text|string} sku
 @property {string} sku_error
 @property {?number|int|float} tax_rate
 @property {string} tax_rate_error
 @property {?boolean} taxable
 @property {string} taxable_error
 @property {?array} entries
 @property {string} entries_error
 @property {Layaways_Object} layaways
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Layaways_Payment_Refunds
 @property {Layaways_Payment_Refunds_Properties} properties
 @property {Layaways_Payment_Refunds_Has} has
 @property {Layaways_Payment_Refunds_Is} is
 @property {Layaways_Payment_Refunds_Object} object
 */
/**
 @typedef {Object.<any>} Layaways_Payment_Refunds_Properties
 @property {number|int|float} amount
 @property {date|string} created
 @property {number|int} creator
 @property {number|int} layaway
 @property {text|string} method
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} note
 @property {number|int} payment
 @property {number|int} pkey
 @property {number|int} register
 @property {number|int|float} restocking_fee
 @property {text|string} transaction_id
 @property {array} payments
 @property {array} restock_items
 */
/**
 @typedef {Object.<any>} Layaways_Payment_Refunds_Has
 */
/**
 @typedef {Object.<any>} Layaways_Payment_Refunds_Is
 @property {Layaways_Payments_Object} layaway_payments
 @property {Layaways_Object} layaways
 @property {Registers_Object} registers
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Layaways_Payment_Refunds_Object
 @property {?number|int|float} amount
 @property {string} amount_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int} layaway
 @property {string} layaway_error
 @property {?text|string} method
 @property {string} method_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} note
 @property {string} note_error
 @property {?number|int} payment
 @property {string} payment_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} register
 @property {string} register_error
 @property {?number|int|float} restocking_fee
 @property {string} restocking_fee_error
 @property {?text|string} transaction_id
 @property {string} transaction_id_error
 @property {?array} payments
 @property {string} payments_error
 @property {?array} restock_items
 @property {string} restock_items_error
 @property {Layaways_Payments_Object} layaway_payments
 @property {Layaways_Object} layaways
 @property {Registers_Object} registers
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Layaways_Payments
 @property {Layaways_Payments_Properties} properties
 @property {Layaways_Payments_Has} has
 @property {Layaways_Payments_Is} is
 @property {Layaways_Payments_Object} object
 */
/**
 @typedef {Object.<any>} Layaways_Payments_Properties
 @property {number|int|float} amount
 @property {number|int|float} cash_amount
 @property {boolean} cc_fee
 @property {number|int|float} check_amount
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} description
 @property {number|int|float} invoice_amount
 @property {boolean} is_debit
 @property {number|int} layaway
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int|float} other_amount
 @property {text|string} payment_method
 @property {number|int} pkey
 @property {number|int|float} processor_amount
 @property {number|int} register
 @property {number|int|float} zelle_amount
 @property {text|string} credit_card_cvc
 @property {text|string} credit_card_expiry
 @property {text|string} credit_card_name
 @property {text|string} credit_card_number
 @property {number|int|float} remaining
 */
/**
 @typedef {Object.<any>} Layaways_Payments_Has
 */
/**
 @typedef {Object.<any>} Layaways_Payments_Is
 @property {Layaways_Object} layaways
 @property {Registers_Object} registers
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Layaways_Payments_Object
 @property {?number|int|float} amount
 @property {string} amount_error
 @property {?number|int|float} cash_amount
 @property {string} cash_amount_error
 @property {?boolean} cc_fee
 @property {string} cc_fee_error
 @property {?number|int|float} check_amount
 @property {string} check_amount_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} description
 @property {string} description_error
 @property {?number|int|float} invoice_amount
 @property {string} invoice_amount_error
 @property {?boolean} is_debit
 @property {string} is_debit_error
 @property {?number|int} layaway
 @property {string} layaway_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int|float} other_amount
 @property {string} other_amount_error
 @property {?text|string} payment_method
 @property {string} payment_method_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} processor_amount
 @property {string} processor_amount_error
 @property {?number|int} register
 @property {string} register_error
 @property {?number|int|float} zelle_amount
 @property {string} zelle_amount_error
 @property {?text|string} credit_card_cvc
 @property {string} credit_card_cvc_error
 @property {?text|string} credit_card_expiry
 @property {string} credit_card_expiry_error
 @property {?text|string} credit_card_name
 @property {string} credit_card_name_error
 @property {?text|string} credit_card_number
 @property {string} credit_card_number_error
 @property {?number|int|float} remaining
 @property {string} remaining_error
 @property {Layaways_Object} layaways
 @property {Registers_Object} registers
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Layaways_Products
 @property {Layaways_Products_Properties} properties
 @property {Layaways_Products_Has} has
 @property {Layaways_Products_Is} is
 @property {Layaways_Products_Object} object
 */
/**
 @typedef {Object.<any>} Layaways_Products_Properties
 @property {text|string} cost
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} discount_amount
 @property {number|int} layaway
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {number|int} pkey
 @property {number|int|float} price
 @property {number|int} product
 @property {text|string} serial
 @property {text|string} sku
 */
/**
 @typedef {Object.<any>} Layaways_Products_Has
 */
/**
 @typedef {Object.<any>} Layaways_Products_Is
 @property {Layaways_Object} layaways
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Layaways_Products_Object
 @property {?text|string} cost
 @property {string} cost_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} discount_amount
 @property {string} discount_amount_error
 @property {?number|int} layaway
 @property {string} layaway_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} price
 @property {string} price_error
 @property {?number|int} product
 @property {string} product_error
 @property {?text|string} serial
 @property {string} serial_error
 @property {?text|string} sku
 @property {string} sku_error
 @property {Layaways_Object} layaways
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Layaways_Services
 @property {Layaways_Services_Properties} properties
 @property {Layaways_Services_Has} has
 @property {Layaways_Services_Is} is
 @property {Layaways_Services_Object} object
 */
/**
 @typedef {Object.<any>} Layaways_Services_Properties
 @property {number|int|float} cost
 @property {date|string} created
 @property {number|int} creator
 @property {number|int|float} discount_amount
 @property {number|int} layaway
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {number|int} pkey
 @property {number|int|float} price
 @property {number|int} quantity
 @property {text|string} serial_number
 @property {number|int} service
 @property {text|string} sku
 @property {number|int|float} tax_rate
 @property {boolean} taxable
 */
/**
 @typedef {Object.<any>} Layaways_Services_Has
 */
/**
 @typedef {Object.<any>} Layaways_Services_Is
 @property {Layaways_Object} layaways
 @property {Services_Object} services
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Layaways_Services_Object
 @property {?number|int|float} cost
 @property {string} cost_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int|float} discount_amount
 @property {string} discount_amount_error
 @property {?number|int} layaway
 @property {string} layaway_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} price
 @property {string} price_error
 @property {?number|int} quantity
 @property {string} quantity_error
 @property {?text|string} serial_number
 @property {string} serial_number_error
 @property {?number|int} service
 @property {string} service_error
 @property {?text|string} sku
 @property {string} sku_error
 @property {?number|int|float} tax_rate
 @property {string} tax_rate_error
 @property {?boolean} taxable
 @property {string} taxable_error
 @property {Layaways_Object} layaways
 @property {Services_Object} services
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Locations
 @property {Locations_Properties} properties
 @property {Locations_Has} has
 @property {Locations_Is} is
 @property {Locations_Object} object
 */
/**
 @typedef {Object.<any>} Locations_Properties
 @property {number|int} account
 @property {text|string} city
 @property {date|string} created
 @property {number|int} creator
 @property {number|int|float} credit_card_fee
 @property {text|string} description
 @property {email} email
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {text|string} phone
 @property {number|int} pkey
 @property {text|string} state
 @property {text|string} store_number
 @property {text|string} street_1
 @property {text|string} street_2
 @property {number|int|float} tax_rate_city
 @property {number|int|float} tax_rate_county
 @property {number|int|float} tax_rate_fflboss
 @property {number|int|float} tax_rate_special
 @property {number|int|float} tax_rate_state
 @property {text|string} zip
 */
/**
 @typedef {Object.<any>} Locations_Has
 */
/**
 @typedef {Object.<any>} Locations_Is
 @property {Accounts_Object} accounts
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Locations_Object
 @property {?number|int} account
 @property {string} account_error
 @property {?text|string} city
 @property {string} city_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int|float} credit_card_fee
 @property {string} credit_card_fee_error
 @property {?text|string} description
 @property {string} description_error
 @property {?email} email
 @property {string} email_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?text|string} phone
 @property {string} phone_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} store_number
 @property {string} store_number_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?text|string} street_2
 @property {string} street_2_error
 @property {?number|int|float} tax_rate_city
 @property {string} tax_rate_city_error
 @property {?number|int|float} tax_rate_county
 @property {string} tax_rate_county_error
 @property {?number|int|float} tax_rate_fflboss
 @property {string} tax_rate_fflboss_error
 @property {?number|int|float} tax_rate_special
 @property {string} tax_rate_special_error
 @property {?number|int|float} tax_rate_state
 @property {string} tax_rate_state_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {Accounts_Object} accounts
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Locations_Sales
 @property {Locations_Sales_Properties} properties
 @property {Locations_Sales_Has} has
 @property {Locations_Sales_Is} is
 @property {Locations_Sales_Object} object
 */
/**
 @typedef {Object.<any>} Locations_Sales_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {date|string} date
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {number|int|float} non_taxable_items
 @property {number|int} pkey
 @property {number|int|float} tax_rate
 @property {number|int|float} taxable_sales_items
 @property {number|int|float} total_sales
 @property {number|int|float} total_tax
 */
/**
 @typedef {Object.<any>} Locations_Sales_Has
 */
/**
 @typedef {Object.<any>} Locations_Sales_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Locations_Sales_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?date|string} date
 @property {string} date_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int|float} non_taxable_items
 @property {string} non_taxable_items_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} tax_rate
 @property {string} tax_rate_error
 @property {?number|int|float} taxable_sales_items
 @property {string} taxable_sales_items_error
 @property {?number|int|float} total_sales
 @property {string} total_sales_error
 @property {?number|int|float} total_tax
 @property {string} total_tax_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Memberships
 @property {Memberships_Properties} properties
 @property {Memberships_Has} has
 @property {Memberships_Is} is
 @property {Memberships_Object} object
 */
/**
 @typedef {Object.<any>} Memberships_Properties
 @property {number|int} account
 @property {number|int} billing_day
 @property {text|string} billing_period
 @property {date|string} cancelled_at
 @property {text|string} card_brand
 @property {text|string} card_last_four
 @property {number|int|float} cost_per_month
 @property {date|string} created
 @property {number|int} creator
 @property {number|int} customer
 @property {number|int|float} discount_percentage
 @property {number|int} failed_billing_count
 @property {number|int} free_range_minutes
 @property {text|string} inventory_group_discounts
 @property {text|string} ipospays_reference_id
 @property {text|string} ipospays_subscription_id
 @property {date|string} last_bill_date
 @property {text|string} last_billing_message
 @property {text|string} last_billing_status
 @property {number|int} membership_plan
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {date|string} next_bill_date
 @property {text|string} notes
 @property {text|string} payment_processor
 @property {number|int} pkey
 @property {date|string} start_date
 @property {text|string} status
 @property {number|int} terminal
 @property {date|string} tokenized_at
 @property {boolean} allow_multiple_memberships
 @property {boolean} bill_now
 @property {date|string} billing_day_picker_date
 @property {number|int} billing_max_failed_attempts
 @property {boolean} capture_new_card
 @property {number|int} covered_member_count
 @property {array} covered_member_ids
 @property {number|int} covered_member_limit
 @property {array} covered_members
 @property {boolean} covered_members_ready
 @property {number|int} customer_lookup
 @property {date|string} end_date
 @property {number|int} history_customer
 @property {text|string} history_event_type
 @property {number|int} history_limit
 @property {number|int} history_membership
 @property {text|string} history_order
 @property {number|int} history_page
 @property {text|string} history_search
 @property {text|string} history_sort
 @property {text|string} history_status
 @property {boolean} include_activity
 @property {number|int|float} inventory_group_discount_amount
 @property {number|int|float} inventory_group_discount_percentage
 @property {array} inventory_group_discount_sku_classes
 @property {text|string} inventory_group_discount_target
 @property {text|string} inventory_group_discount_type
 @property {date|string} last_failed_billing_at
 @property {number|int} membership_action
 @property {boolean} membership_discounts_additive
 @property {array} paying_customer
 @property {text|string} payment_reference_id
 @property {number|int} range_minutes_balance
 @property {date|string} range_minutes_cycle_end
 @property {date|string} range_minutes_cycle_start
 @property {boolean} retry_canceled
 @property {number|int} reusable_membership
 */
/**
 @typedef {Object.<any>} Memberships_Has
 */
/**
 @typedef {Object.<any>} Memberships_Is
 @property {Accounts_Object} accounts
 @property {Terminals_Altrupay_Object} altrupay_spin_processing
 @property {Customers_Object} customers
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Memberships_Object
 @property {?number|int} account
 @property {string} account_error
 @property {?number|int} billing_day
 @property {string} billing_day_error
 @property {?text|string} billing_period
 @property {string} billing_period_error
 @property {?date|string} cancelled_at
 @property {string} cancelled_at_error
 @property {?text|string} card_brand
 @property {string} card_brand_error
 @property {?text|string} card_last_four
 @property {string} card_last_four_error
 @property {?number|int|float} cost_per_month
 @property {string} cost_per_month_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?number|int|float} discount_percentage
 @property {string} discount_percentage_error
 @property {?number|int} failed_billing_count
 @property {string} failed_billing_count_error
 @property {?number|int} free_range_minutes
 @property {string} free_range_minutes_error
 @property {?text|string} inventory_group_discounts
 @property {string} inventory_group_discounts_error
 @property {?text|string} ipospays_reference_id
 @property {string} ipospays_reference_id_error
 @property {?text|string} ipospays_subscription_id
 @property {string} ipospays_subscription_id_error
 @property {?date|string} last_bill_date
 @property {string} last_bill_date_error
 @property {?text|string} last_billing_message
 @property {string} last_billing_message_error
 @property {?text|string} last_billing_status
 @property {string} last_billing_status_error
 @property {?number|int} membership_plan
 @property {string} membership_plan_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?date|string} next_bill_date
 @property {string} next_bill_date_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?text|string} payment_processor
 @property {string} payment_processor_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?date|string} start_date
 @property {string} start_date_error
 @property {?text|string} status
 @property {string} status_error
 @property {?number|int} terminal
 @property {string} terminal_error
 @property {?date|string} tokenized_at
 @property {string} tokenized_at_error
 @property {?boolean} allow_multiple_memberships
 @property {string} allow_multiple_memberships_error
 @property {?boolean} bill_now
 @property {string} bill_now_error
 @property {?date|string} billing_day_picker_date
 @property {string} billing_day_picker_date_error
 @property {?number|int} billing_max_failed_attempts
 @property {string} billing_max_failed_attempts_error
 @property {?boolean} capture_new_card
 @property {string} capture_new_card_error
 @property {?number|int} covered_member_count
 @property {string} covered_member_count_error
 @property {?array} covered_member_ids
 @property {string} covered_member_ids_error
 @property {?number|int} covered_member_limit
 @property {string} covered_member_limit_error
 @property {?array} covered_members
 @property {string} covered_members_error
 @property {?boolean} covered_members_ready
 @property {string} covered_members_ready_error
 @property {?number|int} customer_lookup
 @property {string} customer_lookup_error
 @property {?date|string} end_date
 @property {string} end_date_error
 @property {?number|int} history_customer
 @property {string} history_customer_error
 @property {?text|string} history_event_type
 @property {string} history_event_type_error
 @property {?number|int} history_limit
 @property {string} history_limit_error
 @property {?number|int} history_membership
 @property {string} history_membership_error
 @property {?text|string} history_order
 @property {string} history_order_error
 @property {?number|int} history_page
 @property {string} history_page_error
 @property {?text|string} history_search
 @property {string} history_search_error
 @property {?text|string} history_sort
 @property {string} history_sort_error
 @property {?text|string} history_status
 @property {string} history_status_error
 @property {?boolean} include_activity
 @property {string} include_activity_error
 @property {?number|int|float} inventory_group_discount_amount
 @property {string} inventory_group_discount_amount_error
 @property {?number|int|float} inventory_group_discount_percentage
 @property {string} inventory_group_discount_percentage_error
 @property {?array} inventory_group_discount_sku_classes
 @property {string} inventory_group_discount_sku_classes_error
 @property {?text|string} inventory_group_discount_target
 @property {string} inventory_group_discount_target_error
 @property {?text|string} inventory_group_discount_type
 @property {string} inventory_group_discount_type_error
 @property {?date|string} last_failed_billing_at
 @property {string} last_failed_billing_at_error
 @property {?number|int} membership_action
 @property {string} membership_action_error
 @property {?boolean} membership_discounts_additive
 @property {string} membership_discounts_additive_error
 @property {?array} paying_customer
 @property {string} paying_customer_error
 @property {?text|string} payment_reference_id
 @property {string} payment_reference_id_error
 @property {?number|int} range_minutes_balance
 @property {string} range_minutes_balance_error
 @property {?date|string} range_minutes_cycle_end
 @property {string} range_minutes_cycle_end_error
 @property {?date|string} range_minutes_cycle_start
 @property {string} range_minutes_cycle_start_error
 @property {?boolean} retry_canceled
 @property {string} retry_canceled_error
 @property {?number|int} reusable_membership
 @property {string} reusable_membership_error
 @property {Accounts_Object} accounts
 @property {Terminals_Altrupay_Object} altrupay_spin_processing
 @property {Customers_Object} customers
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Processors
 @property {Processors_Properties} properties
 @property {Processors_Has} has
 @property {Processors_Is} is
 @property {Processors_Object} object
 */
/**
 @typedef {Object.<any>} Processors_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Processors_Has
 */
/**
 @typedef {Object.<any>} Processors_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Processors_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Range_Manager
 @property {Range_Manager_Properties} properties
 @property {Range_Manager_Has} has
 @property {Range_Manager_Is} is
 @property {Range_Manager_Object} object
 */
/**
 @typedef {Object.<any>} Range_Manager_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int} pkey
 @property {array} blocks
 @property {array} bookings
 @property {array} lanes
 @property {array} rate_plans
 @property {array} settings
 @property {array} summary
 @property {array} waitlist
 */
/**
 @typedef {Object.<any>} Range_Manager_Has
 */
/**
 @typedef {Object.<any>} Range_Manager_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Range_Manager_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?array} blocks
 @property {string} blocks_error
 @property {?array} bookings
 @property {string} bookings_error
 @property {?array} lanes
 @property {string} lanes_error
 @property {?array} rate_plans
 @property {string} rate_plans_error
 @property {?array} settings
 @property {string} settings_error
 @property {?array} summary
 @property {string} summary_error
 @property {?array} waitlist
 @property {string} waitlist_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Registers
 @property {Registers_Properties} properties
 @property {Registers_Has} has
 @property {Registers_Is} is
 @property {Registers_Object} object
 */
/**
 @typedef {Object.<any>} Registers_Properties
 @property {number|int} account
 @property {number|int|float} amount_current
 @property {date|string} created
 @property {number|int} creator
 @property {number|int} location
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Registers_Has
 */
/**
 @typedef {Object.<any>} Registers_Is
 @property {Accounts_Object} accounts
 @property {Locations_Object} locations
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Registers_Object
 @property {?number|int} account
 @property {string} account_error
 @property {?number|int|float} amount_current
 @property {string} amount_current_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int} location
 @property {string} location_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {Accounts_Object} accounts
 @property {Locations_Object} locations
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Registers_Ledgers
 @property {Registers_Ledgers_Properties} properties
 @property {Registers_Ledgers_Has} has
 @property {Registers_Ledgers_Is} is
 @property {Registers_Ledgers_Object} object
 */
/**
 @typedef {Object.<any>} Registers_Ledgers_Properties
 @property {number|int|float} amount
 @property {number|int|float} cash_deposit
 @property {number|int|float} cash_left_in_drawer
 @property {number|int|float} counted_amount
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} denominations
 @property {text|string} event
 @property {number|int|float} expected_amount
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} note
 @property {number|int} pkey
 @property {number|int} register
 @property {number|int} transaction
 @property {number|int|float} variance
 @property {text|string} method
 @property {boolean} type
 @property {text|string} user_note
 */
/**
 @typedef {Object.<any>} Registers_Ledgers_Has
 */
/**
 @typedef {Object.<any>} Registers_Ledgers_Is
 @property {Registers_Object} registers
 @property {Transactions_Object} transactions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Registers_Ledgers_Object
 @property {?number|int|float} amount
 @property {string} amount_error
 @property {?number|int|float} cash_deposit
 @property {string} cash_deposit_error
 @property {?number|int|float} cash_left_in_drawer
 @property {string} cash_left_in_drawer_error
 @property {?number|int|float} counted_amount
 @property {string} counted_amount_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} denominations
 @property {string} denominations_error
 @property {?text|string} event
 @property {string} event_error
 @property {?number|int|float} expected_amount
 @property {string} expected_amount_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} note
 @property {string} note_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} register
 @property {string} register_error
 @property {?number|int} transaction
 @property {string} transaction_error
 @property {?number|int|float} variance
 @property {string} variance_error
 @property {?text|string} method
 @property {string} method_error
 @property {?boolean} type
 @property {string} type_error
 @property {?text|string} user_note
 @property {string} user_note_error
 @property {Registers_Object} registers
 @property {Transactions_Object} transactions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Services
 @property {Services_Properties} properties
 @property {Services_Has} has
 @property {Services_Is} is
 @property {Services_Object} object
 */
/**
 @typedef {Object.<any>} Services_Properties
 @property {number|int} account
 @property {date|string} created
 @property {number|int} creator
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {text|string} notes
 @property {number|int} pkey
 @property {number|int|float} price
 @property {number|int|float} price_purchase
 @property {boolean} removed
 @property {boolean} taxable
 */
/**
 @typedef {Object.<any>} Services_Has
 */
/**
 @typedef {Object.<any>} Services_Is
 @property {Accounts_Object} accounts
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Services_Object
 @property {?number|int} account
 @property {string} account_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} price
 @property {string} price_error
 @property {?number|int|float} price_purchase
 @property {string} price_purchase_error
 @property {?boolean} removed
 @property {string} removed_error
 @property {?boolean} taxable
 @property {string} taxable_error
 @property {Accounts_Object} accounts
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Sessions
 @property {Sessions_Properties} properties
 @property {Sessions_Has} has
 @property {Sessions_Is} is
 @property {Sessions_Object} object
 */
/**
 @typedef {Object.<any>} Sessions_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Sessions_Has
 */
/**
 @typedef {Object.<any>} Sessions_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Sessions_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Signup_Addons
 @property {Signup_Addons_Properties} properties
 @property {Signup_Addons_Has} has
 @property {Signup_Addons_Is} is
 @property {Signup_Addons_Object} object
 */
/**
 @typedef {Object.<any>} Signup_Addons_Properties
 @property {boolean} active
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} description
 @property {text|string} icon
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int} module_pkey
 @property {text|string} name
 @property {number|int} pkey
 @property {text|string} requires_slug
 @property {text|string} signup_price
 @property {text|string} slug
 @property {number|int} sort_order
 @property {text|string} standard_price
 @property {text|string} stripe_plan_id
 */
/**
 @typedef {Object.<any>} Signup_Addons_Has
 */
/**
 @typedef {Object.<any>} Signup_Addons_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Signup_Addons_Object
 @property {?boolean} active
 @property {string} active_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} description
 @property {string} description_error
 @property {?text|string} icon
 @property {string} icon_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int} module_pkey
 @property {string} module_pkey_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} requires_slug
 @property {string} requires_slug_error
 @property {?text|string} signup_price
 @property {string} signup_price_error
 @property {?text|string} slug
 @property {string} slug_error
 @property {?number|int} sort_order
 @property {string} sort_order_error
 @property {?text|string} standard_price
 @property {string} standard_price_error
 @property {?text|string} stripe_plan_id
 @property {string} stripe_plan_id_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Skus
 @property {Skus_Properties} properties
 @property {Skus_Has} has
 @property {Skus_Is} is
 @property {Skus_Object} object
 */
/**
 @typedef {Object.<any>} Skus_Properties
 @property {number|int} ammoready_inv
 @property {number|int} class
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} description
 @property {number|int} location
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {number|int} pkey
 @property {number|int} price_minimum
 @property {number|int} price_purchase
 @property {number|int} price_retail
 @property {number|int} quantity_max
 @property {number|int} quantity_min
 @property {text|string} sku
 @property {boolean} taxable
 @property {text|string} class_other
 @property {number|int} quantity_current
 @property {boolean} should_sync
 */
/**
 @typedef {Object.<any>} Skus_Has
 */
/**
 @typedef {Object.<any>} Skus_Is
 @property {Ammoready_Inventory_Object} ammoready_inventory
 @property {Locations_Object} locations
 @property {Skus_Classes_Object} sku_classes
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Skus_Object
 @property {?number|int} ammoready_inv
 @property {string} ammoready_inv_error
 @property {?number|int} class
 @property {string} class_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} description
 @property {string} description_error
 @property {?number|int} location
 @property {string} location_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} price_minimum
 @property {string} price_minimum_error
 @property {?number|int} price_purchase
 @property {string} price_purchase_error
 @property {?number|int} price_retail
 @property {string} price_retail_error
 @property {?number|int} quantity_max
 @property {string} quantity_max_error
 @property {?number|int} quantity_min
 @property {string} quantity_min_error
 @property {?text|string} sku
 @property {string} sku_error
 @property {?boolean} taxable
 @property {string} taxable_error
 @property {?text|string} class_other
 @property {string} class_other_error
 @property {?number|int} quantity_current
 @property {string} quantity_current_error
 @property {?boolean} should_sync
 @property {string} should_sync_error
 @property {Ammoready_Inventory_Object} ammoready_inventory
 @property {Locations_Object} locations
 @property {Skus_Classes_Object} sku_classes
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Skus_Classes
 @property {Skus_Classes_Properties} properties
 @property {Skus_Classes_Has} has
 @property {Skus_Classes_Is} is
 @property {Skus_Classes_Object} object
 */
/**
 @typedef {Object.<any>} Skus_Classes_Properties
 @property {number|int} account
 @property {text|string} color
 @property {date|string} created
 @property {number|int} creator
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {number|int} pkey
 @property {boolean} should_override
 @property {number|int|float} tax_override
 */
/**
 @typedef {Object.<any>} Skus_Classes_Has
 */
/**
 @typedef {Object.<any>} Skus_Classes_Is
 @property {Accounts_Object} accounts
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Skus_Classes_Object
 @property {?number|int} account
 @property {string} account_error
 @property {?text|string} color
 @property {string} color_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?boolean} should_override
 @property {string} should_override_error
 @property {?number|int|float} tax_override
 @property {string} tax_override_error
 @property {Accounts_Object} accounts
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} States
 @property {States_Properties} properties
 @property {States_Has} has
 @property {States_Is} is
 @property {States_Object} object
 */
/**
 @typedef {Object.<any>} States_Properties
 @property {text|string} abbreviation
 @property {date|string} created
 @property {number|int} creator
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} States_Has
 */
/**
 @typedef {Object.<any>} States_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} States_Object
 @property {?text|string} abbreviation
 @property {string} abbreviation_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Terminals
 @property {Terminals_Properties} properties
 @property {Terminals_Has} has
 @property {Terminals_Is} is
 @property {Terminals_Object} object
 */
/**
 @typedef {Object.<any>} Terminals_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Terminals_Has
 */
/**
 @typedef {Object.<any>} Terminals_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Terminals_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Terminals_Altrupay
 @property {Terminals_Altrupay_Properties} properties
 @property {Terminals_Altrupay_Has} has
 @property {Terminals_Altrupay_Is} is
 @property {Terminals_Altrupay_Object} object
 */
/**
 @typedef {Object.<any>} Terminals_Altrupay_Properties
 @property {text|string} authkey
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} ecom_token
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} nickname
 @property {number|int} pkey
 @property {text|string} tpn
 @property {text|string} checkout
 */
/**
 @typedef {Object.<any>} Terminals_Altrupay_Has
 */
/**
 @typedef {Object.<any>} Terminals_Altrupay_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Terminals_Altrupay_Object
 @property {?text|string} authkey
 @property {string} authkey_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} ecom_token
 @property {string} ecom_token_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} nickname
 @property {string} nickname_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} tpn
 @property {string} tpn_error
 @property {?text|string} checkout
 @property {string} checkout_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Trades
 @property {Trades_Properties} properties
 @property {Trades_Has} has
 @property {Trades_Is} is
 @property {Trades_Object} object
 */
/**
 @typedef {Object.<any>} Trades_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {text|string} notes
 @property {number|int} pkey
 @property {number|int|float} price
 @property {number|int|float} quantity
 */
/**
 @typedef {Object.<any>} Trades_Has
 */
/**
 @typedef {Object.<any>} Trades_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Trades_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} price
 @property {string} price_error
 @property {?number|int|float} quantity
 @property {string} quantity_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Transactions
 @property {Transactions_Properties} properties
 @property {Transactions_Has} has
 @property {Transactions_Is} is
 @property {Transactions_Object} object
 */
/**
 @typedef {Object.<any>} Transactions_Properties
 @property {number|int|float} amount
 @property {number|int|float} cash_amount
 @property {number|int|float} cash_discount_amount
 @property {number|int|float} cash_discount_percentage
 @property {number|int|float} cc_fee_amount
 @property {number|int} certificate
 @property {number|int|float} check_amount
 @property {text|string} client
 @property {date|string} created
 @property {number|int} creator
 @property {number|int} customer
 @property {date|string} date
 @property {text|string} description
 @property {number|int|float} discount_amount
 @property {number|int} discount_percentage
 @property {number|int|float} invoice_amount
 @property {text|string} invoice_notes
 @property {number|int|float} invoice_remaining
 @property {number|int} invoice_status
 @property {boolean} is_debit
 @property {number|int} location
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} notes
 @property {text|string} order_id
 @property {text|string} order_ip_address
 @property {text|string} order_po_number
 @property {number|int|float} other_amount
 @property {text|string} payment_method
 @property {number|int} pkey
 @property {number|int|float} processor_amount
 @property {text|string} processor_user_id
 @property {text|string} receipt_email
 @property {boolean} refunded
 @property {text|string} salesman
 @property {text|string} signature_data
 @property {number|int|float} tax_amount
 @property {text|string} tax_json
 @property {text|string} terminal_card_type
 @property {text|string} terminal_cardholder_name
 @property {text|string} terminal_entry_type
 @property {text|string} terminal_id
 @property {number|int} terminal_last_four
 @property {text|string} terminal_payment_type
 @property {text|string} transaction_id
 @property {number|int} user
 @property {number|int|float} zelle_amount
 */
/**
 @typedef {Object.<any>} Transactions_Has
 @property {Transactions_Refunds_Object[]} 0
 @property {Transactions_Items_Object[]} 1
 @property {Transactions_Products_Object[]} 2
 @property {Transactions_Consignments_Object[]} 3
 @property {Transactions_Services_Object[]} 4
 @property {Transactions_Trades_Object[]} 5
 @property {Invoice_Payments_Object[]} 6
 */
/**
 @typedef {Object.<any>} Transactions_Is
 @property {Certificates_Object} certificates
 @property {Customers_Object} customers
 @property {Locations_Object} locations
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Transactions_Object
 @property {?number|int|float} amount
 @property {string} amount_error
 @property {?number|int|float} cash_amount
 @property {string} cash_amount_error
 @property {?number|int|float} cash_discount_amount
 @property {string} cash_discount_amount_error
 @property {?number|int|float} cash_discount_percentage
 @property {string} cash_discount_percentage_error
 @property {?number|int|float} cc_fee_amount
 @property {string} cc_fee_amount_error
 @property {?number|int} certificate
 @property {string} certificate_error
 @property {?number|int|float} check_amount
 @property {string} check_amount_error
 @property {?text|string} client
 @property {string} client_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?date|string} date
 @property {string} date_error
 @property {?text|string} description
 @property {string} description_error
 @property {?number|int|float} discount_amount
 @property {string} discount_amount_error
 @property {?number|int} discount_percentage
 @property {string} discount_percentage_error
 @property {?number|int|float} invoice_amount
 @property {string} invoice_amount_error
 @property {?text|string} invoice_notes
 @property {string} invoice_notes_error
 @property {?number|int|float} invoice_remaining
 @property {string} invoice_remaining_error
 @property {?number|int} invoice_status
 @property {string} invoice_status_error
 @property {?boolean} is_debit
 @property {string} is_debit_error
 @property {?number|int} location
 @property {string} location_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?text|string} order_id
 @property {string} order_id_error
 @property {?text|string} order_ip_address
 @property {string} order_ip_address_error
 @property {?text|string} order_po_number
 @property {string} order_po_number_error
 @property {?number|int|float} other_amount
 @property {string} other_amount_error
 @property {?text|string} payment_method
 @property {string} payment_method_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} processor_amount
 @property {string} processor_amount_error
 @property {?text|string} processor_user_id
 @property {string} processor_user_id_error
 @property {?text|string} receipt_email
 @property {string} receipt_email_error
 @property {?boolean} refunded
 @property {string} refunded_error
 @property {?text|string} salesman
 @property {string} salesman_error
 @property {?text|string} signature_data
 @property {string} signature_data_error
 @property {?number|int|float} tax_amount
 @property {string} tax_amount_error
 @property {?text|string} tax_json
 @property {string} tax_json_error
 @property {?text|string} terminal_card_type
 @property {string} terminal_card_type_error
 @property {?text|string} terminal_cardholder_name
 @property {string} terminal_cardholder_name_error
 @property {?text|string} terminal_entry_type
 @property {string} terminal_entry_type_error
 @property {?text|string} terminal_id
 @property {string} terminal_id_error
 @property {?number|int} terminal_last_four
 @property {string} terminal_last_four_error
 @property {?text|string} terminal_payment_type
 @property {string} terminal_payment_type_error
 @property {?text|string} transaction_id
 @property {string} transaction_id_error
 @property {?number|int} user
 @property {string} user_error
 @property {?number|int|float} zelle_amount
 @property {string} zelle_amount_error
 @property {Transactions_Refunds_Object[]} 0
 @property {Transactions_Items_Object[]} 1
 @property {Transactions_Products_Object[]} 2
 @property {Transactions_Consignments_Object[]} 3
 @property {Transactions_Services_Object[]} 4
 @property {Transactions_Trades_Object[]} 5
 @property {Invoice_Payments_Object[]} 6
 @property {Certificates_Object} certificates
 @property {Customers_Object} customers
 @property {Locations_Object} locations
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Transactions_Certificates
 @property {Transactions_Certificates_Properties} properties
 @property {Transactions_Certificates_Has} has
 @property {Transactions_Certificates_Is} is
 @property {Transactions_Certificates_Object} object
 */
/**
 @typedef {Object.<any>} Transactions_Certificates_Properties
 @property {number|int|float} amount_used
 @property {number|int} certificate
 @property {date|string} created
 @property {number|int} creator
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int} pkey
 @property {number|int} transaction
 */
/**
 @typedef {Object.<any>} Transactions_Certificates_Has
 */
/**
 @typedef {Object.<any>} Transactions_Certificates_Is
 @property {Certificates_Object} certificates
 @property {Transactions_Object} transactions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Transactions_Certificates_Object
 @property {?number|int|float} amount_used
 @property {string} amount_used_error
 @property {?number|int} certificate
 @property {string} certificate_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} transaction
 @property {string} transaction_error
 @property {Certificates_Object} certificates
 @property {Transactions_Object} transactions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Transactions_Entries
 @property {Transactions_Entries_Properties} properties
 @property {Transactions_Entries_Has} has
 @property {Transactions_Entries_Is} is
 @property {Transactions_Entries_Object} object
 */
/**
 @typedef {Object.<any>} Transactions_Entries_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {number|int|float} decimal
 @property {number|int|float} discount_amount
 @property {number|int} inventory
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {number|int} pkey
 @property {number|int|float} price
 @property {number|int} product
 @property {number|int} quantity
 @property {number|int|float} refund_amount
 @property {number|int} refund_quantity
 @property {boolean} refunded
 @property {text|string} serial_number
 @property {number|int} sku
 @property {number|int|float} tax_rate
 @property {boolean} taxable
 @property {number|int} transaction
 @property {text|string} transaction_type
 @property {number|int} true_pkey
 */
/**
 @typedef {Object.<any>} Transactions_Entries_Has
 */
/**
 @typedef {Object.<any>} Transactions_Entries_Is
 @property {Inventories_Object} inventories
 @property {Transactions_Object} transactions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Transactions_Entries_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int|float} decimal
 @property {string} decimal_error
 @property {?number|int|float} discount_amount
 @property {string} discount_amount_error
 @property {?number|int} inventory
 @property {string} inventory_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} price
 @property {string} price_error
 @property {?number|int} product
 @property {string} product_error
 @property {?number|int} quantity
 @property {string} quantity_error
 @property {?number|int|float} refund_amount
 @property {string} refund_amount_error
 @property {?number|int} refund_quantity
 @property {string} refund_quantity_error
 @property {?boolean} refunded
 @property {string} refunded_error
 @property {?text|string} serial_number
 @property {string} serial_number_error
 @property {?number|int} sku
 @property {string} sku_error
 @property {?number|int|float} tax_rate
 @property {string} tax_rate_error
 @property {?boolean} taxable
 @property {string} taxable_error
 @property {?number|int} transaction
 @property {string} transaction_error
 @property {?text|string} transaction_type
 @property {string} transaction_type_error
 @property {?number|int} true_pkey
 @property {string} true_pkey_error
 @property {Inventories_Object} inventories
 @property {Transactions_Object} transactions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Transactions_Items
 @property {Transactions_Items_Properties} properties
 @property {Transactions_Items_Has} has
 @property {Transactions_Items_Is} is
 @property {Transactions_Items_Object} object
 */
/**
 @typedef {Object.<any>} Transactions_Items_Properties
 @property {number|int|float} cost
 @property {date|string} created
 @property {number|int} creator
 @property {number|int|float} discount_amount
 @property {number|int} inventory
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {number|int} pkey
 @property {number|int|float} price
 @property {number|int} quantity
 @property {boolean} refunded
 @property {text|string} serial_number
 @property {text|string} sku
 @property {number|int|float} tax_rate
 @property {boolean} taxable
 @property {number|int} transaction
 */
/**
 @typedef {Object.<any>} Transactions_Items_Has
 */
/**
 @typedef {Object.<any>} Transactions_Items_Is
 @property {Inventories_Object} inventories
 @property {Transactions_Object} transactions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Transactions_Items_Object
 @property {?number|int|float} cost
 @property {string} cost_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int|float} discount_amount
 @property {string} discount_amount_error
 @property {?number|int} inventory
 @property {string} inventory_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} price
 @property {string} price_error
 @property {?number|int} quantity
 @property {string} quantity_error
 @property {?boolean} refunded
 @property {string} refunded_error
 @property {?text|string} serial_number
 @property {string} serial_number_error
 @property {?text|string} sku
 @property {string} sku_error
 @property {?number|int|float} tax_rate
 @property {string} tax_rate_error
 @property {?boolean} taxable
 @property {string} taxable_error
 @property {?number|int} transaction
 @property {string} transaction_error
 @property {Inventories_Object} inventories
 @property {Transactions_Object} transactions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Transactions_Printable_Customization
 @property {Transactions_Printable_Customization_Properties} properties
 @property {Transactions_Printable_Customization_Has} has
 @property {Transactions_Printable_Customization_Is} is
 @property {Transactions_Printable_Customization_Object} object
 */
/**
 @typedef {Object.<any>} Transactions_Printable_Customization_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {string} logo
 @property {text|string} message
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int} pkey
 @property {text|string} return_policy
 @property {text|string} warranty
 */
/**
 @typedef {Object.<any>} Transactions_Printable_Customization_Has
 */
/**
 @typedef {Object.<any>} Transactions_Printable_Customization_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Transactions_Printable_Customization_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?string} logo
 @property {string} logo_error
 @property {?text|string} message
 @property {string} message_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} return_policy
 @property {string} return_policy_error
 @property {?text|string} warranty
 @property {string} warranty_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Transactions_Products
 @property {Transactions_Products_Properties} properties
 @property {Transactions_Products_Has} has
 @property {Transactions_Products_Is} is
 @property {Transactions_Products_Object} object
 */
/**
 @typedef {Object.<any>} Transactions_Products_Properties
 @property {number|int|float} cost
 @property {date|string} created
 @property {number|int} creator
 @property {number|int|float} discount_amount
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {number|int} pkey
 @property {number|int|float} price
 @property {number|int} product
 @property {boolean} refunded
 @property {text|string} serial
 @property {text|string} sku
 @property {number|int|float} tax_rate
 @property {boolean} taxable
 @property {number|int} transaction
 */
/**
 @typedef {Object.<any>} Transactions_Products_Has
 */
/**
 @typedef {Object.<any>} Transactions_Products_Is
 @property {Transactions_Object} transactions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Transactions_Products_Object
 @property {?number|int|float} cost
 @property {string} cost_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int|float} discount_amount
 @property {string} discount_amount_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} price
 @property {string} price_error
 @property {?number|int} product
 @property {string} product_error
 @property {?boolean} refunded
 @property {string} refunded_error
 @property {?text|string} serial
 @property {string} serial_error
 @property {?text|string} sku
 @property {string} sku_error
 @property {?number|int|float} tax_rate
 @property {string} tax_rate_error
 @property {?boolean} taxable
 @property {string} taxable_error
 @property {?number|int} transaction
 @property {string} transaction_error
 @property {Transactions_Object} transactions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Transactions_Refunds
 @property {Transactions_Refunds_Properties} properties
 @property {Transactions_Refunds_Has} has
 @property {Transactions_Refunds_Is} is
 @property {Transactions_Refunds_Object} object
 */
/**
 @typedef {Object.<any>} Transactions_Refunds_Properties
 @property {number|int|float} amount
 @property {number|int} consignment
 @property {date|string} created
 @property {number|int} creator
 @property {number|int} item
 @property {text|string} method
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} note
 @property {number|int} pkey
 @property {number|int} product
 @property {number|int} quantity
 @property {number|int} register
 @property {number|int|float} restocking_fee
 @property {number|int} service
 @property {number|int} transaction
 @property {text|string} transaction_id
 @property {array} consignments
 @property {array} items
 @property {array} products
 @property {boolean} restock
 */
/**
 @typedef {Object.<any>} Transactions_Refunds_Has
 */
/**
 @typedef {Object.<any>} Transactions_Refunds_Is
 @property {Registers_Object} registers
 @property {Transactions_Consignments_Object} transaction_consignments
 @property {Transactions_Items_Object} transaction_items
 @property {Transactions_Products_Object} transaction_products
 @property {Transactions_Services_Object} transaction_services
 @property {Transactions_Object} transactions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Transactions_Refunds_Object
 @property {?number|int|float} amount
 @property {string} amount_error
 @property {?number|int} consignment
 @property {string} consignment_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int} item
 @property {string} item_error
 @property {?text|string} method
 @property {string} method_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} note
 @property {string} note_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} product
 @property {string} product_error
 @property {?number|int} quantity
 @property {string} quantity_error
 @property {?number|int} register
 @property {string} register_error
 @property {?number|int|float} restocking_fee
 @property {string} restocking_fee_error
 @property {?number|int} service
 @property {string} service_error
 @property {?number|int} transaction
 @property {string} transaction_error
 @property {?text|string} transaction_id
 @property {string} transaction_id_error
 @property {?array} consignments
 @property {string} consignments_error
 @property {?array} items
 @property {string} items_error
 @property {?array} products
 @property {string} products_error
 @property {?boolean} restock
 @property {string} restock_error
 @property {Registers_Object} registers
 @property {Transactions_Consignments_Object} transaction_consignments
 @property {Transactions_Items_Object} transaction_items
 @property {Transactions_Products_Object} transaction_products
 @property {Transactions_Services_Object} transaction_services
 @property {Transactions_Object} transactions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Transactions_Services
 @property {Transactions_Services_Properties} properties
 @property {Transactions_Services_Has} has
 @property {Transactions_Services_Is} is
 @property {Transactions_Services_Object} object
 */
/**
 @typedef {Object.<any>} Transactions_Services_Properties
 @property {number|int|float} cost
 @property {date|string} created
 @property {number|int} creator
 @property {number|int|float} discount_amount
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {number|int} pkey
 @property {number|int|float} price
 @property {number|int} quantity
 @property {boolean} refunded
 @property {number|int} refunded_quantity
 @property {text|string} serial_number
 @property {number|int} service
 @property {text|string} sku
 @property {number|int|float} tax_rate
 @property {boolean} taxable
 @property {number|int} transaction
 */
/**
 @typedef {Object.<any>} Transactions_Services_Has
 */
/**
 @typedef {Object.<any>} Transactions_Services_Is
 @property {Services_Object} services
 @property {Transactions_Object} transactions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Transactions_Services_Object
 @property {?number|int|float} cost
 @property {string} cost_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int|float} discount_amount
 @property {string} discount_amount_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} price
 @property {string} price_error
 @property {?number|int} quantity
 @property {string} quantity_error
 @property {?boolean} refunded
 @property {string} refunded_error
 @property {?number|int} refunded_quantity
 @property {string} refunded_quantity_error
 @property {?text|string} serial_number
 @property {string} serial_number_error
 @property {?number|int} service
 @property {string} service_error
 @property {?text|string} sku
 @property {string} sku_error
 @property {?number|int|float} tax_rate
 @property {string} tax_rate_error
 @property {?boolean} taxable
 @property {string} taxable_error
 @property {?number|int} transaction
 @property {string} transaction_error
 @property {Services_Object} services
 @property {Transactions_Object} transactions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Transactions_Trades
 @property {Transactions_Trades_Properties} properties
 @property {Transactions_Trades_Has} has
 @property {Transactions_Trades_Is} is
 @property {Transactions_Trades_Object} object
 */
/**
 @typedef {Object.<any>} Transactions_Trades_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {number|int} pkey
 @property {number|int|float} price
 @property {number|int} quantity
 @property {number|int} trade
 @property {number|int} transaction
 */
/**
 @typedef {Object.<any>} Transactions_Trades_Has
 */
/**
 @typedef {Object.<any>} Transactions_Trades_Is
 @property {Trades_Object} trades
 @property {Transactions_Object} transactions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Transactions_Trades_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} price
 @property {string} price_error
 @property {?number|int} quantity
 @property {string} quantity_error
 @property {?number|int} trade
 @property {string} trade_error
 @property {?number|int} transaction
 @property {string} transaction_error
 @property {Trades_Object} trades
 @property {Transactions_Object} transactions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Unexpected_Errors
 @property {Unexpected_Errors_Properties} properties
 @property {Unexpected_Errors_Has} has
 @property {Unexpected_Errors_Is} is
 @property {Unexpected_Errors_Object} object
 */
/**
 @typedef {Object.<any>} Unexpected_Errors_Properties
 @property {number|int} account
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} message
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} path
 @property {number|int} pkey
 @property {text|string} stack
 @property {number|int} user
 */
/**
 @typedef {Object.<any>} Unexpected_Errors_Has
 */
/**
 @typedef {Object.<any>} Unexpected_Errors_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Unexpected_Errors_Object
 @property {?number|int} account
 @property {string} account_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} message
 @property {string} message_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} path
 @property {string} path_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} stack
 @property {string} stack_error
 @property {?number|int} user
 @property {string} user_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Users
 @property {Users_Properties} properties
 @property {Users_Has} has
 @property {Users_Is} is
 @property {Users_Object} object
 */
/**
 @typedef {Object.<any>} Users_Properties
 @property {number|int} access
 @property {date|string} created
 @property {number|int} creator
 @property {email} email
 @property {text|string} employee_id
 @property {number|int} location
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name_first
 @property {text|string} name_last
 @property {text|string} password
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Users_Has
 */
/**
 @typedef {Object.<any>} Users_Is
 @property {Locations_Object} locations
 @property {Users_Accesses_Object} user_accesses
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Users_Object
 @property {?number|int} access
 @property {string} access_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?email} email
 @property {string} email_error
 @property {?text|string} employee_id
 @property {string} employee_id_error
 @property {?number|int} location
 @property {string} location_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name_first
 @property {string} name_first_error
 @property {?text|string} name_last
 @property {string} name_last_error
 @property {?text|string} password
 @property {string} password_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {Locations_Object} locations
 @property {Users_Accesses_Object} user_accesses
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Users_Accesses
 @property {Users_Accesses_Properties} properties
 @property {Users_Accesses_Has} has
 @property {Users_Accesses_Is} is
 @property {Users_Accesses_Object} object
 */
/**
 @typedef {Object.<any>} Users_Accesses_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Users_Accesses_Has
 */
/**
 @typedef {Object.<any>} Users_Accesses_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Users_Accesses_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Version
 @property {Version_Properties} properties
 @property {Version_Has} has
 @property {Version_Is} is
 @property {Version_Object} object
 */
/**
 @typedef {Object.<any>} Version_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int} pkey
 @property {text|string} version_number
 */
/**
 @typedef {Object.<any>} Version_Has
 */
/**
 @typedef {Object.<any>} Version_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Version_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} version_number
 @property {string} version_number_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Waiver_Signings
 @property {Waiver_Signings_Properties} properties
 @property {Waiver_Signings_Has} has
 @property {Waiver_Signings_Is} is
 @property {Waiver_Signings_Object} object
 */
/**
 @typedef {Object.<any>} Waiver_Signings_Properties
 @property {number|int} account
 @property {date|string} completed_at
 @property {date|string} created
 @property {number|int} creator
 @property {number|int} customer
 @property {date|string} expires_at
 @property {number|int} kiosk
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int} pkey
 @property {text|string} signature_file
 @property {text|string} signed_pdf
 @property {text|string} signer_name
 @property {text|string} status
 @property {number|int} waiver
 */
/**
 @typedef {Object.<any>} Waiver_Signings_Has
 */
/**
 @typedef {Object.<any>} Waiver_Signings_Is
 @property {Customers_Object} customers
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 @property {Waivers_Object} waivers
 */
/**
 @typedef {Object.<any>} Waiver_Signings_Object
 @property {?number|int} account
 @property {string} account_error
 @property {?date|string} completed_at
 @property {string} completed_at_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?date|string} expires_at
 @property {string} expires_at_error
 @property {?number|int} kiosk
 @property {string} kiosk_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} signature_file
 @property {string} signature_file_error
 @property {?text|string} signed_pdf
 @property {string} signed_pdf_error
 @property {?text|string} signer_name
 @property {string} signer_name_error
 @property {?text|string} status
 @property {string} status_error
 @property {?number|int} waiver
 @property {string} waiver_error
 @property {Customers_Object} customers
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 @property {Waivers_Object} waivers
 */
/**
 @typedef {Object.<any>} Waivers
 @property {Waivers_Properties} properties
 @property {Waivers_Has} has
 @property {Waivers_Is} is
 @property {Waivers_Object} object
 */
/**
 @typedef {Object.<any>} Waivers_Properties
 @property {number|int} account
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_name
 @property {number|int} expires_after_days
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_name
 @property {text|string} name
 @property {number|int} pkey
 @property {text|string} signature_box
 @property {text|string} template_file
 */
/**
 @typedef {Object.<any>} Waivers_Has
 */
/**
 @typedef {Object.<any>} Waivers_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Waivers_Object
 @property {?number|int} account
 @property {string} account_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_name
 @property {string} creator_name_error
 @property {?number|int} expires_after_days
 @property {string} expires_after_days_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_name
 @property {string} modifier_name_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} signature_box
 @property {string} signature_box_error
 @property {?text|string} template_file
 @property {string} template_file_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Work_Orders
 @property {Work_Orders_Properties} properties
 @property {Work_Orders_Has} has
 @property {Work_Orders_Is} is
 @property {Work_Orders_Object} object
 */
/**
 @typedef {Object.<any>} Work_Orders_Properties
 @property {number|int} account
 @property {number|int|float} amount
 @property {number|int} assigned_user
 @property {number|int|float} cc_fees
 @property {date|string} completed_date
 @property {date|string} created
 @property {number|int} creator
 @property {number|int} customer
 @property {text|string} customer_notes
 @property {text|string} description
 @property {date|string} estimated_date
 @property {number|int} location
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int|float} non_taxable_subtotal
 @property {number|int} pkey
 @property {text|string} po_number
 @property {text|string} receipt_email
 @property {number|int|float} remaining
 @property {text|string} salesman
 @property {text|string} status
 @property {number|int|float} tax_amount
 @property {text|string} tax_json
 @property {number|int|float} tax_rate
 @property {number|int|float} taxable_subtotal
 @property {text|string} work_order_notes
 @property {number|int|float} cash_amount
 @property {number|int|float} check_amount
 @property {text|string} credit_card_cvc
 @property {text|string} credit_card_expiry
 @property {text|string} credit_card_name
 @property {text|string} credit_card_number
 @property {text|string} description
 @property {array} entries
 @property {number|int|float} invoice_amount
 @property {boolean} is_debit
 @property {number|int|float} other_amount
 @property {number|int|float} processor_amount
 @property {number|int} register
 @property {number|int|float} remaining
 @property {number|int|float} sub_total_amount
 @property {number|int|float} tax_amount
 @property {text|string} tax_overpayment_action
 @property {number|int|float} tax_overpayment_amount
 @property {text|string} tax_overpayment_note
 @property {text|string} terminal
 @property {number|int|float} zelle_amount
 */
/**
 @typedef {Object.<any>} Work_Orders_Has
 @property {Work_Orders_Services_Object[]} 0
 */
/**
 @typedef {Object.<any>} Work_Orders_Is
 @property {Accounts_Object} accounts
 @property {Customers_Object} customers
 @property {Locations_Object} locations
 @property {Registers_Object} registers
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Work_Orders_Object
 @property {?number|int} account
 @property {string} account_error
 @property {?number|int|float} amount
 @property {string} amount_error
 @property {?number|int} assigned_user
 @property {string} assigned_user_error
 @property {?number|int|float} cc_fees
 @property {string} cc_fees_error
 @property {?date|string} completed_date
 @property {string} completed_date_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?text|string} customer_notes
 @property {string} customer_notes_error
 @property {?text|string} description
 @property {string} description_error
 @property {?date|string} estimated_date
 @property {string} estimated_date_error
 @property {?number|int} location
 @property {string} location_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int|float} non_taxable_subtotal
 @property {string} non_taxable_subtotal_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} po_number
 @property {string} po_number_error
 @property {?text|string} receipt_email
 @property {string} receipt_email_error
 @property {?number|int|float} remaining
 @property {string} remaining_error
 @property {?text|string} salesman
 @property {string} salesman_error
 @property {?text|string} status
 @property {string} status_error
 @property {?number|int|float} tax_amount
 @property {string} tax_amount_error
 @property {?text|string} tax_json
 @property {string} tax_json_error
 @property {?number|int|float} tax_rate
 @property {string} tax_rate_error
 @property {?number|int|float} taxable_subtotal
 @property {string} taxable_subtotal_error
 @property {?text|string} work_order_notes
 @property {string} work_order_notes_error
 @property {?number|int|float} cash_amount
 @property {string} cash_amount_error
 @property {?number|int|float} check_amount
 @property {string} check_amount_error
 @property {?text|string} credit_card_cvc
 @property {string} credit_card_cvc_error
 @property {?text|string} credit_card_expiry
 @property {string} credit_card_expiry_error
 @property {?text|string} credit_card_name
 @property {string} credit_card_name_error
 @property {?text|string} credit_card_number
 @property {string} credit_card_number_error
 @property {?text|string} description
 @property {string} description_error
 @property {?array} entries
 @property {string} entries_error
 @property {?number|int|float} invoice_amount
 @property {string} invoice_amount_error
 @property {?boolean} is_debit
 @property {string} is_debit_error
 @property {?number|int|float} other_amount
 @property {string} other_amount_error
 @property {?number|int|float} processor_amount
 @property {string} processor_amount_error
 @property {?number|int} register
 @property {string} register_error
 @property {?number|int|float} remaining
 @property {string} remaining_error
 @property {?number|int|float} sub_total_amount
 @property {string} sub_total_amount_error
 @property {?number|int|float} tax_amount
 @property {string} tax_amount_error
 @property {?text|string} tax_overpayment_action
 @property {string} tax_overpayment_action_error
 @property {?number|int|float} tax_overpayment_amount
 @property {string} tax_overpayment_amount_error
 @property {?text|string} tax_overpayment_note
 @property {string} tax_overpayment_note_error
 @property {?text|string} terminal
 @property {string} terminal_error
 @property {?number|int|float} zelle_amount
 @property {string} zelle_amount_error
 @property {Work_Orders_Services_Object[]} 0
 @property {Accounts_Object} accounts
 @property {Customers_Object} customers
 @property {Locations_Object} locations
 @property {Registers_Object} registers
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Work_Orders_Entries
 @property {Work_Orders_Entries_Properties} properties
 @property {Work_Orders_Entries_Has} has
 @property {Work_Orders_Entries_Is} is
 @property {Work_Orders_Entries_Object} object
 */
/**
 @typedef {Object.<any>} Work_Orders_Entries_Properties
 @property {number|int|float} cost
 @property {date|string} created
 @property {number|int} creator
 @property {number|int|float} discount_amount
 @property {number|int} inventory
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {number|int} pkey
 @property {number|int|float} price
 @property {number|int} product
 @property {number|int} quantity
 @property {text|string} serial_number
 @property {text|string} sku
 @property {number|int|float} tax_rate
 @property {boolean} taxable
 @property {text|string} type
 @property {number|int} work_order
 */
/**
 @typedef {Object.<any>} Work_Orders_Entries_Has
 */
/**
 @typedef {Object.<any>} Work_Orders_Entries_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 @property {Work_Orders_Object} work_orders
 */
/**
 @typedef {Object.<any>} Work_Orders_Entries_Object
 @property {?number|int|float} cost
 @property {string} cost_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int|float} discount_amount
 @property {string} discount_amount_error
 @property {?number|int} inventory
 @property {string} inventory_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} price
 @property {string} price_error
 @property {?number|int} product
 @property {string} product_error
 @property {?number|int} quantity
 @property {string} quantity_error
 @property {?text|string} serial_number
 @property {string} serial_number_error
 @property {?text|string} sku
 @property {string} sku_error
 @property {?number|int|float} tax_rate
 @property {string} tax_rate_error
 @property {?boolean} taxable
 @property {string} taxable_error
 @property {?text|string} type
 @property {string} type_error
 @property {?number|int} work_order
 @property {string} work_order_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 @property {Work_Orders_Object} work_orders
 */
/**
 @typedef {Object.<any>} Work_Orders_Items
 @property {Work_Orders_Items_Properties} properties
 @property {Work_Orders_Items_Has} has
 @property {Work_Orders_Items_Is} is
 @property {Work_Orders_Items_Object} object
 */
/**
 @typedef {Object.<any>} Work_Orders_Items_Properties
 @property {number|int|float} cost
 @property {date|string} created
 @property {number|int} creator
 @property {number|int|float} discount_amount
 @property {number|int} item_fkey
 @property {text|string} item_type
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {number|int} pkey
 @property {number|int|float} price
 @property {number|int} quantity
 @property {text|string} serial_number
 @property {text|string} sku
 @property {number|int|float} tax_rate
 @property {boolean} taxable
 @property {number|int} work_order
 @property {array} entries
 */
/**
 @typedef {Object.<any>} Work_Orders_Items_Has
 */
/**
 @typedef {Object.<any>} Work_Orders_Items_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 @property {Work_Orders_Object} work_orders
 */
/**
 @typedef {Object.<any>} Work_Orders_Items_Object
 @property {?number|int|float} cost
 @property {string} cost_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int|float} discount_amount
 @property {string} discount_amount_error
 @property {?number|int} item_fkey
 @property {string} item_fkey_error
 @property {?text|string} item_type
 @property {string} item_type_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} price
 @property {string} price_error
 @property {?number|int} quantity
 @property {string} quantity_error
 @property {?text|string} serial_number
 @property {string} serial_number_error
 @property {?text|string} sku
 @property {string} sku_error
 @property {?number|int|float} tax_rate
 @property {string} tax_rate_error
 @property {?boolean} taxable
 @property {string} taxable_error
 @property {?number|int} work_order
 @property {string} work_order_error
 @property {?array} entries
 @property {string} entries_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 @property {Work_Orders_Object} work_orders
 */
/**
 @typedef {Object.<any>} Work_Orders_Payments
 @property {Work_Orders_Payments_Properties} properties
 @property {Work_Orders_Payments_Has} has
 @property {Work_Orders_Payments_Is} is
 @property {Work_Orders_Payments_Object} object
 */
/**
 @typedef {Object.<any>} Work_Orders_Payments_Properties
 @property {number|int|float} amount
 @property {number|int|float} cash_amount
 @property {boolean} cc_fee
 @property {number|int|float} check_amount
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} description
 @property {number|int|float} invoice_amount
 @property {boolean} is_debit
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int|float} other_amount
 @property {text|string} payment_method
 @property {number|int} pkey
 @property {number|int|float} processor_amount
 @property {number|int} register
 @property {number|int} work_order
 @property {number|int|float} zelle_amount
 @property {text|string} credit_card_cvc
 @property {text|string} credit_card_expiry
 @property {text|string} credit_card_name
 @property {text|string} credit_card_number
 @property {number|int|float} remaining
 */
/**
 @typedef {Object.<any>} Work_Orders_Payments_Has
 */
/**
 @typedef {Object.<any>} Work_Orders_Payments_Is
 @property {Registers_Object} registers
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 @property {Work_Orders_Object} work_orders
 */
/**
 @typedef {Object.<any>} Work_Orders_Payments_Object
 @property {?number|int|float} amount
 @property {string} amount_error
 @property {?number|int|float} cash_amount
 @property {string} cash_amount_error
 @property {?boolean} cc_fee
 @property {string} cc_fee_error
 @property {?number|int|float} check_amount
 @property {string} check_amount_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} description
 @property {string} description_error
 @property {?number|int|float} invoice_amount
 @property {string} invoice_amount_error
 @property {?boolean} is_debit
 @property {string} is_debit_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int|float} other_amount
 @property {string} other_amount_error
 @property {?text|string} payment_method
 @property {string} payment_method_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} processor_amount
 @property {string} processor_amount_error
 @property {?number|int} register
 @property {string} register_error
 @property {?number|int} work_order
 @property {string} work_order_error
 @property {?number|int|float} zelle_amount
 @property {string} zelle_amount_error
 @property {?text|string} credit_card_cvc
 @property {string} credit_card_cvc_error
 @property {?text|string} credit_card_expiry
 @property {string} credit_card_expiry_error
 @property {?text|string} credit_card_name
 @property {string} credit_card_name_error
 @property {?text|string} credit_card_number
 @property {string} credit_card_number_error
 @property {?number|int|float} remaining
 @property {string} remaining_error
 @property {Registers_Object} registers
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 @property {Work_Orders_Object} work_orders
 */
/**
 @typedef {Object.<any>} Work_Orders_Services
 @property {Work_Orders_Services_Properties} properties
 @property {Work_Orders_Services_Has} has
 @property {Work_Orders_Services_Is} is
 @property {Work_Orders_Services_Object} object
 */
/**
 @typedef {Object.<any>} Work_Orders_Services_Properties
 @property {number|int|float} cost
 @property {date|string} created
 @property {number|int} creator
 @property {number|int|float} discount_amount
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {number|int} pkey
 @property {number|int|float} price
 @property {number|int} quantity
 @property {text|string} serial_number
 @property {number|int} service
 @property {text|string} sku
 @property {number|int|float} tax_rate
 @property {boolean} taxable
 @property {number|int} work_order
 */
/**
 @typedef {Object.<any>} Work_Orders_Services_Has
 */
/**
 @typedef {Object.<any>} Work_Orders_Services_Is
 @property {Services_Object} services
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 @property {Work_Orders_Object} work_orders
 */
/**
 @typedef {Object.<any>} Work_Orders_Services_Object
 @property {?number|int|float} cost
 @property {string} cost_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int|float} discount_amount
 @property {string} discount_amount_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} price
 @property {string} price_error
 @property {?number|int} quantity
 @property {string} quantity_error
 @property {?text|string} serial_number
 @property {string} serial_number_error
 @property {?number|int} service
 @property {string} service_error
 @property {?text|string} sku
 @property {string} sku_error
 @property {?number|int|float} tax_rate
 @property {string} tax_rate_error
 @property {?boolean} taxable
 @property {string} taxable_error
 @property {?number|int} work_order
 @property {string} work_order_error
 @property {Services_Object} services
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 @property {Work_Orders_Object} work_orders
 */
/**
 @typedef {Object.<any>} Year_End_Reports
 @property {Year_End_Reports_Properties} properties
 @property {Year_End_Reports_Has} has
 @property {Year_End_Reports_Is} is
 @property {Year_End_Reports_Object} object
 */
/**
 @typedef {Object.<any>} Year_End_Reports_Properties
 @property {number|int} account
 @property {number|int|float} cost
 @property {date|string} created
 @property {number|int} creator
 @property {date|string} end_year
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int} pkey
 @property {number|int|float} price
 @property {number|int|float} purchase_price_end
 @property {number|int|float} purchase_price_start
 @property {number|int} quantity_end
 @property {number|int} quantity_start
 @property {number|int|float} retail_price_end
 @property {number|int|float} retail_price_start
 @property {number|int} sku
 @property {number|int} sku_number
 @property {date|string} start_year
 @property {date|string} report_end_year
 @property {date|string} report_start_year
 */
/**
 @typedef {Object.<any>} Year_End_Reports_Has
 */
/**
 @typedef {Object.<any>} Year_End_Reports_Is
 @property {Accounts_Object} accounts
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Year_End_Reports_Object
 @property {?number|int} account
 @property {string} account_error
 @property {?number|int|float} cost
 @property {string} cost_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?date|string} end_year
 @property {string} end_year_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} price
 @property {string} price_error
 @property {?number|int|float} purchase_price_end
 @property {string} purchase_price_end_error
 @property {?number|int|float} purchase_price_start
 @property {string} purchase_price_start_error
 @property {?number|int} quantity_end
 @property {string} quantity_end_error
 @property {?number|int} quantity_start
 @property {string} quantity_start_error
 @property {?number|int|float} retail_price_end
 @property {string} retail_price_end_error
 @property {?number|int|float} retail_price_start
 @property {string} retail_price_start_error
 @property {?number|int} sku
 @property {string} sku_error
 @property {?number|int} sku_number
 @property {string} sku_number_error
 @property {?date|string} start_year
 @property {string} start_year_error
 @property {?date|string} report_end_year
 @property {string} report_end_year_error
 @property {?date|string} report_start_year
 @property {string} report_start_year_error
 @property {Accounts_Object} accounts
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
const Types = {
	Accounts : {
		_name : "Accounts",
	},
	Accounts_Billing : {
		_name : "Accounts_Billing",
	},
	Accounts_Create : {
		_name : "Accounts_Create",
	},
	Accounts_Customizations : {
		_name : "Accounts_Customizations",
	},
	Admins_Locations : {
		_name : "Admins_Locations",
	},
	Admins_Logins : {
		_name : "Admins_Logins",
	},
	Accounts_Processors : {
		_name : "Accounts_Processors",
	},
	Admins_Securities : {
		_name : "Admins_Securities",
	},
	Accounts_Subscriptions : {
		_name : "Accounts_Subscriptions",
	},
	Accounts_Tokens : {
		_name : "Accounts_Tokens",
	},
	Admins : {
		_name : "Admins",
	},
	Ammoready_Inventory : {
		_name : "Ammoready_Inventory",
	},
	Certificates : {
		_name : "Certificates",
	},
	Checkout_Quick_Picks : {
		_name : "Checkout_Quick_Picks",
	},
	Checkouts : {
		_name : "Checkouts",
	},
	Checkouts_Consignments : {
		_name : "Checkouts_Consignments",
	},
	Checkouts_Items : {
		_name : "Checkouts_Items",
	},
	Checkouts_Layaways : {
		_name : "Checkouts_Layaways",
	},
	Checkouts_Products : {
		_name : "Checkouts_Products",
	},
	Checkouts_Services : {
		_name : "Checkouts_Services",
	},
	Checkouts_Trades : {
		_name : "Checkouts_Trades",
	},
	Checkouts_Work_Orders : {
		_name : "Checkouts_Work_Orders",
	},
	Consignments : {
		_name : "Consignments",
	},
	Customers : {
		_name : "Customers",
	},
	Customers_Logs : {
		_name : "Customers_Logs",
	},
	Dashboard : {
		_name : "Dashboard",
	},
	Inventories : {
		_name : "Inventories",
	},
	Inventories_Connected : {
		_name : "Inventories_Connected",
	},
	Inventories_Ledgers : {
		_name : "Inventories_Ledgers",
	},
	Inventories_Serialized : {
		_name : "Inventories_Serialized",
	},
	Invoice_Pay_By_Link : {
		_name : "Invoice_Pay_By_Link",
	},
	Invoices : {
		_name : "Invoices",
	},
	Invoices_Payments : {
		_name : "Invoices_Payments",
	},
	Kiosk_States : {
		_name : "Kiosk_States",
	},
	Kiosks : {
		_name : "Kiosks",
	},
	Layaways : {
		_name : "Layaways",
	},
	Layaways_Entries : {
		_name : "Layaways_Entries",
	},
	Layaways_Items : {
		_name : "Layaways_Items",
	},
	Layaways_Payment_Refunds : {
		_name : "Layaways_Payment_Refunds",
	},
	Layaways_Payments : {
		_name : "Layaways_Payments",
	},
	Layaways_Products : {
		_name : "Layaways_Products",
	},
	Layaways_Services : {
		_name : "Layaways_Services",
	},
	Locations : {
		_name : "Locations",
	},
	Locations_Sales : {
		_name : "Locations_Sales",
	},
	Memberships : {
		_name : "Memberships",
	},
	Processors : {
		_name : "Processors",
	},
	Range_Manager : {
		_name : "Range_Manager",
	},
	Registers : {
		_name : "Registers",
	},
	Registers_Ledgers : {
		_name : "Registers_Ledgers",
	},
	Services : {
		_name : "Services",
	},
	Sessions : {
		_name : "Sessions",
	},
	Signup_Addons : {
		_name : "Signup_Addons",
	},
	Skus : {
		_name : "Skus",
	},
	Skus_Classes : {
		_name : "Skus_Classes",
	},
	States : {
		_name : "States",
	},
	Terminals : {
		_name : "Terminals",
	},
	Terminals_Altrupay : {
		_name : "Terminals_Altrupay",
	},
	Trades : {
		_name : "Trades",
	},
	Transactions : {
		_name : "Transactions",
	},
	Transactions_Certificates : {
		_name : "Transactions_Certificates",
	},
	Transactions_Entries : {
		_name : "Transactions_Entries",
	},
	Transactions_Items : {
		_name : "Transactions_Items",
	},
	Transactions_Printable_Customization : {
		_name : "Transactions_Printable_Customization",
	},
	Transactions_Products : {
		_name : "Transactions_Products",
	},
	Transactions_Refunds : {
		_name : "Transactions_Refunds",
	},
	Transactions_Services : {
		_name : "Transactions_Services",
	},
	Transactions_Trades : {
		_name : "Transactions_Trades",
	},
	Unexpected_Errors : {
		_name : "Unexpected_Errors",
	},
	Users : {
		_name : "Users",
	},
	Users_Accesses : {
		_name : "Users_Accesses",
	},
	Version : {
		_name : "Version",
	},
	Waiver_Signings : {
		_name : "Waiver_Signings",
	},
	Waivers : {
		_name : "Waivers",
	},
	Work_Orders : {
		_name : "Work_Orders",
	},
	Work_Orders_Entries : {
		_name : "Work_Orders_Entries",
	},
	Work_Orders_Items : {
		_name : "Work_Orders_Items",
	},
	Work_Orders_Payments : {
		_name : "Work_Orders_Payments",
	},
	Work_Orders_Services : {
		_name : "Work_Orders_Services",
	},
	Year_End_Reports : {
		_name : "Year_End_Reports",
	},
};
export default Types;
